(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("Zsba3", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0b8b8e62c5806953$export$6503ec6e8aabbaf; }, function (v) { return $0b8b8e62c5806953$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0b8b8e62c5806953$export$f7ad0328861e2f03; }, function (v) { return $0b8b8e62c5806953$export$f7ad0328861e2f03 = v; });
var $0b8b8e62c5806953$export$6503ec6e8aabbaf;
var $0b8b8e62c5806953$export$f7ad0328861e2f03;
"use strict";
var $0b8b8e62c5806953$var$mapping = new Map();
function $0b8b8e62c5806953$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0b8b8e62c5806953$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0b8b8e62c5806953$var$resolve(id) {
    var resolved = $0b8b8e62c5806953$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0b8b8e62c5806953$export$6503ec6e8aabbaf = $0b8b8e62c5806953$var$register;
$0b8b8e62c5806953$export$f7ad0328861e2f03 = $0b8b8e62c5806953$var$resolve;

});

parcelRegister("bCIEV", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $8765e2acac856894$export$bdfd709ae4826697; }, function (v) { return $8765e2acac856894$export$bdfd709ae4826697 = v; });
var $8765e2acac856894$export$bdfd709ae4826697;
var $8765e2acac856894$export$c9e73fbda7da57b6;
var $8765e2acac856894$export$5a759dc7a1cfb72a;
"use strict";
var $8765e2acac856894$var$bundleURL = {};
function $8765e2acac856894$var$getBundleURLCached(id) {
    var value = $8765e2acac856894$var$bundleURL[id];
    if (!value) {
        value = $8765e2acac856894$var$getBundleURL();
        $8765e2acac856894$var$bundleURL[id] = value;
    }
    return value;
}
function $8765e2acac856894$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $8765e2acac856894$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $8765e2acac856894$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $8765e2acac856894$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$8765e2acac856894$export$bdfd709ae4826697 = $8765e2acac856894$var$getBundleURLCached;
$8765e2acac856894$export$c9e73fbda7da57b6 = $8765e2acac856894$var$getBaseURL;
$8765e2acac856894$export$5a759dc7a1cfb72a = $8765e2acac856894$var$getOrigin;

});

parcelRegister("djrMl", function(module, exports) {


module.exports = (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("2XZcl")).then(()=>parcelRequire('9Q7Fk'));

});
parcelRegister("4GIuy", function(module, exports) {
"use strict";

var $9seqW = parcelRequire("9seqW");
module.exports = $9seqW(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("9seqW", function(module, exports) {
"use strict";
var $6e21ecc8bcb30e78$var$cachedBundles = {};
var $6e21ecc8bcb30e78$var$cachedPreloads = {};
var $6e21ecc8bcb30e78$var$cachedPrefetches = {};
function $6e21ecc8bcb30e78$var$getCache(type) {
    switch(type){
        case 'preload':
            return $6e21ecc8bcb30e78$var$cachedPreloads;
        case 'prefetch':
            return $6e21ecc8bcb30e78$var$cachedPrefetches;
        default:
            return $6e21ecc8bcb30e78$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $6e21ecc8bcb30e78$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("fY4Cn", function(module, exports) {


module.exports = (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("a7p0w")).then(()=>parcelRequire('kmcPq'));

});

var $38f1ec6cb7fa7c8d$exports = {};


(parcelRequire("Zsba3")).register((parcelRequire("bCIEV")).getBundleURL('jxnZg'), JSON.parse("[\"jxnZg\",\"app.js\",\"2XZcl\",\"swiper.1e22f548.js\",\"a7p0w\",\"modules.7183cf8a.js\",\"euSuU\",\"app.css\"]"));

function $031feada4a3b44c2$export$2c579a9f1ddaf08d() {
    const dataToolTips = document.querySelectorAll('[data-tooltip-top], [data-tooltip-right], [data-tooltip-bottom], [data-tooltip-left]');
    const toolTipsClick = document.querySelectorAll('[data-tooltip-copy]');
    function getTooltipText(element) {
        return element.dataset.tooltipTop || element.dataset.tooltipRight || element.dataset.tooltipBottom || element.dataset.tooltipLeft;
    }
    dataToolTips.forEach((dataTooltip)=>{
        if (!dataTooltip.querySelector('.tooltip')) {
            const tooltipText = `<span class="tooltip">${getTooltipText(dataTooltip)}</span>`;
            dataTooltip.insertAdjacentHTML('afterbegin', tooltipText);
        }
    });
    toolTipsClick.forEach((toolTipClick)=>{
        toolTipClick.addEventListener('click', function() {
            const tooltip = toolTipClick.querySelector('.tooltip');
            const originalText = getTooltipText(toolTipClick);
            tooltip.textContent = toolTipClick.dataset.tooltipCopy;
            setTimeout(()=>{
                tooltip.textContent = originalText;
            }, 1000);
        });
    });
}
document.addEventListener('DOMContentLoaded', $031feada4a3b44c2$export$2c579a9f1ddaf08d);


document.addEventListener('click', (e)=>{
    // Add class ac-body and hidden to dropdowns
    const accordionBodies = document.querySelectorAll('.ac-body');
    accordionBodies.forEach(function(accordionBody) {
        const accordionHeader = accordionBody.previousElementSibling;
        if (e.target !== accordionBody && e.target !== accordionHeader && !accordionBody.contains(e.target)) {
            accordionHeader.classList.toggle('active');
            accordionBody.classList.toggle('block!');
        }
    });
    // Add class ac-header to the button that opens the dropdown
    if (e.target.classList.contains('ac-header')) {
        const accordionBody = e.target.nextElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle('active');
        accordionBody.classList.toggle('block!');
    }
    if (e.target.classList.contains('overlay')) {
        const overlay = e.target;
        overlay.classList.remove('visible');
    }
});


document.addEventListener('click', (e)=>{
    if (e.target.classList.contains('tab')) {
        const tab = e.target;
        const tabs = document.querySelectorAll('.tab');
        const tabContents = document.querySelectorAll('.tab-content');
        tabs.forEach((tab)=>{
            tab.classList.remove('active');
        });
        tab.classList.add('active');
        tabContents.forEach((tabContent)=>{
            tabContent.classList.remove('active');
            if (tabContent.dataset.tab === tab.dataset.tab) tabContent.classList.add('active');
        });
    }
});


document.addEventListener('click', function(e) {
    if (e.target.closest('.no-close')) return;
    if (e.target.closest('.mobile-no-close')) {
        if (matchMedia('(max-width: 767px)').matches) return;
    }
    const allActive = document.querySelectorAll('[data-dropdown].active');
    const trigger = e.target.closest('[data-dropdown-trigger]');
    const allTriggers = document.querySelectorAll('[data-dropdown-trigger]');
    // Click on trigger
    if (trigger) {
        const id = trigger.getAttribute('data-dropdown-trigger');
        const dropdown = document.querySelector(`[data-dropdown="${id}"]`);
        // If this dropdown is already open → close and abort
        if (dropdown.classList.contains('active')) {
            dropdown.classList.remove('active');
            trigger.classList.remove('active');
            return;
        }
        // Otherwise: close all and open this one
        allActive.forEach((el)=>el.classList.remove('active'));
        dropdown.classList.add('active');
        trigger.classList.add('active');
        return;
    }
    // Click somewhere else → close everything
    allActive.forEach((el)=>el.classList.remove('active'));
    allTriggers.forEach((el)=>el.classList.remove('active'));
});


document.addEventListener('click', (e)=>{
    if (e.target.closest('a')) {
        const link = e.target.closest('a');
        let href = link.getAttribute('href');
        if (!href.startsWith('#') || href.startsWith('#') && href.length < 2 || link.classList.contains('open-gallery')) return;
        e.preventDefault();
        let target = document.querySelector(href);
        if (!target) return;
        let headerOffset = 130;
        let elementPosition = target.offsetTop;
        let offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
});


function $6541fadd07ac8ad5$export$7454541f89b375e() {
    const products = document.querySelectorAll('li.product');
    if (!products || !products.length) return;
    const fallbackQty = parseFloat(liGlobal.defaultProductQty) || 0;
    for (const product of products){
        const buttons = product.querySelectorAll('.loop-variation-button');
        if (!buttons || !buttons.length) continue;
        // 1) If someone is already selected (e.g. WC default via PHP/precompute), respect it.
        let hasSelected = false;
        for (const btn of buttons)if (btn.classList.contains('selected')) {
            hasSelected = true;
            $6541fadd07ac8ad5$export$672e6ebd2e3e46af(btn);
            break;
        }
        if (hasSelected) continue;
        // 2) Otherwise: select first that matches fallback
        let chosen = null;
        for (const btn of buttons){
            const v = parseFloat(btn.dataset.variationValue);
            if (!Number.isFinite(v)) continue;
            if (v >= fallbackQty) {
                chosen = btn;
                break;
            }
        }
        // 3) If none >=, select first (so you always have one selected)
        if (!chosen) chosen = buttons[0];
        chosen.classList.add('selected');
        $6541fadd07ac8ad5$export$672e6ebd2e3e46af(chosen);
    }
}
document.addEventListener('DOMContentLoaded', function() {
    $6541fadd07ac8ad5$export$7454541f89b375e();
});
// Lägg in variations på resultaten från relevanssi live ajax search när de har laddats klart
if (window.jQuery) {
    var $6541fadd07ac8ad5$var$lastHtml = '';
    jQuery(document).on('relevanssi_live_search_shutdown', function(e, $input, $results) {
        if (!$results || !$results.length) return;
        var $ajax = $results.find('.ajax-results');
        if (!$ajax.length) return;
        var html = ($ajax.html() || '').trim();
        if (!html) return;
        if (html === $6541fadd07ac8ad5$var$lastHtml) return;
        $6541fadd07ac8ad5$var$lastHtml = html;
        $6541fadd07ac8ad5$export$7454541f89b375e();
    });
}
function $6541fadd07ac8ad5$export$672e6ebd2e3e46af(button) {
    const product = button.closest('li.product');
    if (!product) return;
    const buttonShowVariations = product.querySelector('.btn-show-variations');
    if (!buttonShowVariations) return;
    const variationValueEl = button.querySelector('.variation-value');
    if (!variationValueEl) return;
    const variationText = variationValueEl.textContent.trim();
    const shortVariationText = variationText.replace(/(\d+)-p.*/i, '$1-p');
    const btnShowVariationPrice = buttonShowVariations.querySelector('.btn-show-variation-price');
    const btnShowVariationName = buttonShowVariations.querySelector('.btn-show-variation-name');
    const btnShowVariationUnitPrice = buttonShowVariations.querySelector('.btn-show-variation-unit-price');
    const priceEl = button.querySelector('.price');
    const unitPriceEl = button.querySelector('.unit-price');
    const lwLoopAddToCart = button.closest('.lw-loop-add-to-cart');
    const variationId = button.dataset.variationId || null;
    const attrs = button.dataset.attrs || null;
    if (lwLoopAddToCart) {
        lwLoopAddToCart.setAttribute('data-selected-variation-id', variationId);
        lwLoopAddToCart.setAttribute('data-selected-attrs', attrs);
    }
    if (btnShowVariationPrice && priceEl) btnShowVariationPrice.textContent = priceEl.textContent;
    if (btnShowVariationName) btnShowVariationName.textContent = shortVariationText;
    if (btnShowVariationUnitPrice) {
        const unitText = unitPriceEl ? unitPriceEl.textContent.trim() : '';
        btnShowVariationUnitPrice.textContent = unitText || '';
    }
}
document.addEventListener('click', function(e) {
    const btn = e.target.closest('.loop-variation-button');
    if (!btn) return;
    const product = btn.closest('li.product');
    product && product.querySelectorAll('.loop-variation-button.selected').forEach((b)=>b.classList.remove('selected'));
    btn.classList.add('selected');
    $6541fadd07ac8ad5$export$672e6ebd2e3e46af(btn);
});


/**
 * Load More functionality with Infinite Scroll and History State Preservation
 * 
 * Features:
 * - Search load more with Relevanssi integration
 * - Regular post/archive load more
 * - Multiple instances support via data-instance-id
 * - Infinite scroll via IntersectionObserver
 * - State preservation: saves loaded content and scroll position per instance
 * - Restores state on back-navigation or revisit
 */ // Track loading state per instance to prevent multiple simultaneous requests
const $9aa4113698f7fa9e$var$loadingStates = new Map();
// Storage key prefix
const $9aa4113698f7fa9e$var$STORAGE_KEY_PREFIX = 'list_state_';
// ============================================================================
// Instance & Container Management
// ============================================================================
/**
 * Get instance ID from button
 */ const $9aa4113698f7fa9e$var$getInstanceId = (button)=>{
    return button?.dataset?.instanceId || null;
};
/**
 * Generate a state key for storage based on button data
 */ const $9aa4113698f7fa9e$var$getStateKey = (button)=>{
    const instanceId = $9aa4113698f7fa9e$var$getInstanceId(button);
    // If we have a search query, use that as part of the key
    if (button?.dataset?.searchQuery) return `search:${button.dataset.searchQuery}`;
    // If we have a category ID, use post type + cat
    if (button?.dataset?.catId) {
        const postType = button.dataset.postType || 'post';
        return `archive:${postType}:${button.dataset.catId}`;
    }
    // Kategoriurvalet ingår i nyckeln: ändras urvalet i admin ska ett sparat
    // state inte återställa den gamla listan vid bakåtnavigering.
    if (button?.dataset?.categories) {
        const instancePart = instanceId || button.dataset.postType || 'post';
        return `instance:${instancePart}:${button.dataset.categories}:${window.location.pathname}`;
    }
    // If we have an instance ID (for page components), use that + path
    if (instanceId) return `instance:${instanceId}:${window.location.pathname}`;
    // Fallback to post type + path
    const postType = button?.dataset?.postType || 'post';
    return `listing:${postType}:${window.location.pathname}`;
};
/**
 * Get storage key for sessionStorage
 */ const $9aa4113698f7fa9e$var$getStorageKey = (stateKey)=>{
    return $9aa4113698f7fa9e$var$STORAGE_KEY_PREFIX + stateKey;
};
/**
 * Get the post container for a button
 * Supports instance-id scoping for multiple components
 */ const $9aa4113698f7fa9e$var$getPostContainer = (button)=>{
    const instanceId = $9aa4113698f7fa9e$var$getInstanceId(button);
    if (instanceId) {
        // Find container with matching instance-id
        const container = document.querySelector(`[data-instance-id="${instanceId}"]`);
        if (container) {
            // The container itself might be the one with instance-id, look for post-listing inside
            const postListing = container.querySelector('.post-listing');
            return postListing || container;
        }
    }
    // Fallback: find closest container and then post-listing
    return button?.closest('.container')?.querySelector('.post-listing');
};
/**
 * Check if instance is currently loading
 */ const $9aa4113698f7fa9e$var$isInstanceLoading = (button)=>{
    const instanceId = $9aa4113698f7fa9e$var$getInstanceId(button) || 'global';
    return $9aa4113698f7fa9e$var$loadingStates.get(instanceId) || false;
};
/**
 * Set loading state for instance
 */ const $9aa4113698f7fa9e$var$setInstanceLoading = (button, loading)=>{
    const instanceId = $9aa4113698f7fa9e$var$getInstanceId(button) || 'global';
    $9aa4113698f7fa9e$var$loadingStates.set(instanceId, loading);
};
// ============================================================================
// State Preservation (sessionStorage)
// ============================================================================
/**
 * Save current state to sessionStorage
 */ const $9aa4113698f7fa9e$var$saveState = (button, container)=>{
    const stateKey = $9aa4113698f7fa9e$var$getStateKey(button);
    if (!stateKey || !container) return;
    const state = {
        html: container.innerHTML,
        paged: button?.dataset.paged || '1',
        maxPages: button?.dataset.maxPages || '',
        scrollY: window.scrollY,
        timestamp: Date.now()
    };
    try {
        sessionStorage.setItem($9aa4113698f7fa9e$var$getStorageKey(stateKey), JSON.stringify(state));
    } catch (e) {
        console.warn('Could not save list state:', e);
    }
};
/**
 * Restore state from sessionStorage
 */ const $9aa4113698f7fa9e$var$restoreState = (button, container)=>{
    const stateKey = $9aa4113698f7fa9e$var$getStateKey(button);
    if (!stateKey || !container) return false;
    try {
        const stored = sessionStorage.getItem($9aa4113698f7fa9e$var$getStorageKey(stateKey));
        if (!stored) return false;
        const state = JSON.parse(stored);
        // Check if state is not too old (30 minutes)
        if (Date.now() - state.timestamp > 1800000) {
            sessionStorage.removeItem($9aa4113698f7fa9e$var$getStorageKey(stateKey));
            return false;
        }
        // Restore HTML content
        container.innerHTML = state.html;
        // Restore button state
        if (button) {
            button.dataset.paged = state.paged;
            if (state.maxPages) button.dataset.maxPages = state.maxPages;
        }
        // Restore scroll position after a small delay (let DOM settle)
        requestAnimationFrame(()=>{
            window.scrollTo(0, state.scrollY);
        });
        // Re-initialize WooCommerce variations
        (0, $6541fadd07ac8ad5$export$7454541f89b375e)();
        return true;
    } catch (e) {
        console.warn('Could not restore list state:', e);
        return false;
    }
};
/**
 * Clear old states from sessionStorage (cleanup)
 */ const $9aa4113698f7fa9e$var$clearOldStates = ()=>{
    try {
        const keysToRemove = [];
        for(let i = 0; i < sessionStorage.length; i++){
            const key = sessionStorage.key(i);
            if (key?.startsWith($9aa4113698f7fa9e$var$STORAGE_KEY_PREFIX)) {
                const stored = sessionStorage.getItem(key);
                if (stored) {
                    const state = JSON.parse(stored);
                    if (Date.now() - state.timestamp > 1800000) keysToRemove.push(key);
                }
            }
        }
        keysToRemove.forEach((key)=>sessionStorage.removeItem(key));
    } catch (e) {
    // Fail silently
    }
};
/**
 * Setup state preservation for all load more instances
 */ const $9aa4113698f7fa9e$var$setupStatePreservation = ()=>{
    const loadMoreButtons = document.querySelectorAll('.load-more');
    loadMoreButtons.forEach((button)=>{
        const container = $9aa4113698f7fa9e$var$getPostContainer(button);
        if (!container) return;
        // Save state when clicking on any link inside the container
        container.addEventListener('click', (e)=>{
            const link = e.target.closest('a');
            if (link && !link.closest('.load-more')) $9aa4113698f7fa9e$var$saveState(button, container);
        });
    });
    // Save all states before page unload
    window.addEventListener('pagehide', ()=>{
        loadMoreButtons.forEach((button)=>{
            const container = $9aa4113698f7fa9e$var$getPostContainer(button);
            if (container) $9aa4113698f7fa9e$var$saveState(button, container);
        });
    });
};
/**
 * Try to restore state for all instances on page load
 */ const $9aa4113698f7fa9e$var$tryRestoreStates = ()=>{
    const loadMoreButtons = document.querySelectorAll('.load-more');
    loadMoreButtons.forEach((button)=>{
        const container = $9aa4113698f7fa9e$var$getPostContainer(button);
        if (!container) return;
        const restored = $9aa4113698f7fa9e$var$restoreState(button, container);
        if (restored) {
            // Hide button if we've loaded all pages
            const maxPages = parseInt(button.dataset.maxPages || '999', 10);
            const currentPage = parseInt(button.dataset.paged || '1', 10);
            if (currentPage >= maxPages) button.style.display = 'none';
        }
    });
};
// ============================================================================
// Core Load More Functions
// ============================================================================
/**
 * Get the load more button from click target
 */ const $9aa4113698f7fa9e$var$getLoadMoreButton = (target)=>target?.closest('.load-more');
/**
 * Set button visual state
 */ const $9aa4113698f7fa9e$var$setButtonState = (button, { loading: loading, disabled: disabled, text: text, hide: hide })=>{
    if (typeof loading !== 'undefined') {
        button.classList.toggle('loading', loading);
        $9aa4113698f7fa9e$var$setInstanceLoading(button, loading);
    }
    if (typeof disabled !== 'undefined') {
        if (disabled) button.setAttribute('disabled', 'disabled');
        else button.removeAttribute('disabled');
    }
    if (typeof text !== 'undefined') {
        const label = button.querySelector('.load-more-text');
        if (label) label.textContent = text;
    }
    if (typeof hide !== 'undefined') button.style.display = hide ? 'none' : '';
};
/**
 * Append posts to container
 */ const $9aa4113698f7fa9e$var$appendPosts = (container, posts = [])=>{
    posts.forEach((post)=>{
        container.insertAdjacentHTML('beforeend', post);
    });
};
/**
 * Check if this is a search load more button
 */ const $9aa4113698f7fa9e$var$isSearchLoadMore = (button)=>{
    return button.dataset.searchQuery && button.dataset.searchQuery.length > 0;
};
// ============================================================================
// Search Load More (Relevanssi)
// ============================================================================
/**
 * Build request data for search load more
 */ const $9aa4113698f7fa9e$var$buildSearchRequestData = (button)=>{
    const data = new FormData();
    const { dataset: dataset } = button;
    const currentPage = parseInt(dataset.paged || '1', 10);
    const nextPage = currentPage + 1;
    data.append('action', 'search_load_more');
    data.append('security', liGlobal.loadMore);
    data.append('search_query', dataset.searchQuery);
    data.append('paged', nextPage);
    if (dataset.postsPerPage) data.append('posts_per_page', dataset.postsPerPage);
    if (dataset.postType) data.append('post_type', dataset.postType);
    return {
        data: data,
        nextPage: nextPage
    };
};
/**
 * Delad POST-helper för load-more-anrop (sök + vanlig). Returnerar payload.data
 * eller kastar ett fel med ett kontext-anpassat nätverksfelmeddelande.
 */ const $9aa4113698f7fa9e$var$postLoadMore = async (formData, networkErrorMessage)=>{
    const response = await fetch(liGlobal.ajaxUrl, {
        method: 'POST',
        body: formData
    });
    if (!response.ok) throw new Error(networkErrorMessage);
    const payload = await response.json();
    if (!payload.success) throw new Error(payload.data?.message || 'Servern returnerade ett fel');
    return payload.data;
};
/**
 * Handle search load more request
 */ const $9aa4113698f7fa9e$var$requestSearchLoadMore = (formData)=>$9aa4113698f7fa9e$var$postLoadMore(formData, "N\xe4tverksfel vid s\xf6kning");
/**
 * Handle successful search load more
 */ const $9aa4113698f7fa9e$var$handleSearchLoadMoreSuccess = (button, container, data, nextPage)=>{
    $9aa4113698f7fa9e$var$appendPosts(container, data.posts);
    button.dataset.paged = nextPage.toString();
    button.dataset.maxPages = data.max_num_pages?.toString() || '';
    if (data.no_more_posts) $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: false,
        disabled: true,
        hide: true
    });
    else $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: false,
        disabled: false
    });
    if (data.posts && data.posts.length > 0) (0, $6541fadd07ac8ad5$export$7454541f89b375e)();
    // Save state after loading more
    $9aa4113698f7fa9e$var$saveState(button, container);
};
/**
 * Load search posts (can be triggered by click or intersection)
 */ const $9aa4113698f7fa9e$var$triggerSearchLoadMore = async (button)=>{
    if ($9aa4113698f7fa9e$var$isInstanceLoading(button) || button.disabled) return;
    const postContainer = $9aa4113698f7fa9e$var$getPostContainer(button);
    if (!postContainer) return;
    $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: true
    });
    const { data: formData, nextPage: nextPage } = $9aa4113698f7fa9e$var$buildSearchRequestData(button);
    try {
        const data = await $9aa4113698f7fa9e$var$requestSearchLoadMore(formData);
        if (data.no_more_posts && !data.posts?.length) {
            $9aa4113698f7fa9e$var$setButtonState(button, {
                loading: false,
                disabled: true,
                hide: true
            });
            return;
        }
        $9aa4113698f7fa9e$var$handleSearchLoadMoreSuccess(button, postContainer, data, nextPage);
    } catch (error) {
        console.error("Kunde inte ladda fler s\xf6kresultat", error);
        $9aa4113698f7fa9e$var$setButtonState(button, {
            loading: false,
            disabled: false
        });
    }
};
/**
 * Main search load more handler (for click events)
 */ const $9aa4113698f7fa9e$var$loadSearchPosts = async (event)=>{
    event.preventDefault();
    const loadMoreBtn = $9aa4113698f7fa9e$var$getLoadMoreButton(event.target);
    if (!loadMoreBtn) return;
    await $9aa4113698f7fa9e$var$triggerSearchLoadMore(loadMoreBtn);
};
// ============================================================================
// Regular Load More (for non-search pages)
// ============================================================================
/**
 * Collect IDs of already loaded posts within a specific container
 */ const $9aa4113698f7fa9e$var$collectExcludedPostIds = (container)=>{
    if (!container) return [
        ...document.querySelectorAll('[data-post-id]')
    ].map((post)=>post.dataset.postId).filter(Boolean);
    return [
        ...container.querySelectorAll('[data-post-id]')
    ].map((post)=>post.dataset.postId).filter(Boolean);
};
/**
 * Build request data for regular load more
 */ const $9aa4113698f7fa9e$var$buildRequestData = (button, container)=>{
    const data = new FormData();
    const { dataset: dataset } = button;
    const currentPage = parseInt(dataset.paged || '1', 10);
    const nextPage = currentPage + 1;
    if (dataset.catId) data.append('cat_id', dataset.catId);
    // Komponentens fasta kategoriurval (ACF post_listing_categories). Utan detta
    // bygger servern en obegränsad fråga och sida 2 innehåller inlägg från
    // kategorier som aldrig valdes i admin.
    if (dataset.categories) data.append('categories', dataset.categories);
    if (dataset.productCategory) data.append('product_id', dataset.productCategory);
    if (dataset.productBrand) data.append('product_brand', dataset.productBrand);
    const excludedIds = $9aa4113698f7fa9e$var$collectExcludedPostIds(container);
    if (excludedIds.length) data.append('exclude', excludedIds.join(','));
    if (dataset.postType) data.append('post_type', dataset.postType);
    data.append('card_class', dataset.cardClass || '');
    data.append('card_body', dataset.cardBody || '');
    data.append('action', 'load_more');
    data.append('security', liGlobal.loadMore);
    data.append('paged', nextPage);
    return {
        data: data,
        nextPage: nextPage
    };
};
/**
 * Request regular load more posts
 */ const $9aa4113698f7fa9e$var$requestLoadMorePosts = (formData)=>$9aa4113698f7fa9e$var$postLoadMore(formData, "N\xe4tverksfel vid Ladda fler-f\xf6rfr\xe5gan");
/**
 * Handle successful regular load more
 */ const $9aa4113698f7fa9e$var$handleLoadMoreSuccess = (button, container, data, nextPage)=>{
    $9aa4113698f7fa9e$var$appendPosts(container, data.posts);
    button.dataset.paged = nextPage.toString();
    button.dataset.maxPages = data.max_num_pages?.toString() || '';
    if (data.no_more_posts) $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: false,
        disabled: true,
        hide: true
    });
    else $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: false,
        disabled: false
    });
    if (data.post_type === 'product') (0, $6541fadd07ac8ad5$export$7454541f89b375e)();
    // Save state after loading more
    $9aa4113698f7fa9e$var$saveState(button, container);
};
/**
 * Handle load more error
 */ const $9aa4113698f7fa9e$var$handleLoadMoreError = (button, error)=>{
    console.error("Kunde inte ladda fler inl\xe4gg", error);
    $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: false,
        disabled: false
    });
};
/**
 * Trigger regular load more (can be triggered by click or intersection)
 */ const $9aa4113698f7fa9e$var$triggerLoadMore = async (button)=>{
    if ($9aa4113698f7fa9e$var$isInstanceLoading(button) || button.disabled) return;
    const postContainer = $9aa4113698f7fa9e$var$getPostContainer(button);
    if (!postContainer) return;
    $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: true
    });
    const { data: formData, nextPage: nextPage } = $9aa4113698f7fa9e$var$buildRequestData(button, postContainer);
    try {
        const data = await $9aa4113698f7fa9e$var$requestLoadMorePosts(formData);
        if (data.no_more_posts && !data.posts?.length) {
            $9aa4113698f7fa9e$var$setButtonState(button, {
                loading: false,
                disabled: true,
                hide: true
            });
            return;
        }
        $9aa4113698f7fa9e$var$handleLoadMoreSuccess(button, postContainer, data, nextPage);
    } catch (error) {
        $9aa4113698f7fa9e$var$handleLoadMoreError(button, error);
    }
};
const $9aa4113698f7fa9e$export$b10b9b608ed3fa77 = async (event)=>{
    event.preventDefault();
    const loadMoreBtn = $9aa4113698f7fa9e$var$getLoadMoreButton(event.target);
    if (!loadMoreBtn) return;
    await $9aa4113698f7fa9e$var$triggerLoadMore(loadMoreBtn);
};
// ============================================================================
// Infinite Scroll with IntersectionObserver
// ============================================================================
/**
 * Initialize infinite scroll for all load more buttons
 */ const $9aa4113698f7fa9e$var$initInfiniteScroll = ()=>{
    const loadMoreButtons = document.querySelectorAll('.load-more[data-infinite-scroll="true"]');
    if (!loadMoreButtons.length) return;
    const observerOptions = {
        root: null,
        rootMargin: '400px',
        threshold: 0
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const button = entry.target;
                if (button.disabled || $9aa4113698f7fa9e$var$isInstanceLoading(button)) {
                    if (button.disabled) observer.unobserve(button);
                    return;
                }
                if ($9aa4113698f7fa9e$var$isSearchLoadMore(button)) $9aa4113698f7fa9e$var$triggerSearchLoadMore(button);
                else $9aa4113698f7fa9e$var$triggerLoadMore(button);
            }
        });
    }, observerOptions);
    loadMoreButtons.forEach((button)=>{
        observer.observe(button);
    });
};
// ============================================================================
// Event Listeners & Initialization
// ============================================================================
// Click handler for manual load more
document.addEventListener('click', (event)=>{
    const loadMoreBtn = event.target.closest('.load-more');
    if (loadMoreBtn) {
        if ($9aa4113698f7fa9e$var$isSearchLoadMore(loadMoreBtn)) $9aa4113698f7fa9e$var$loadSearchPosts(event);
        else $9aa4113698f7fa9e$export$b10b9b608ed3fa77(event);
    }
});
// Initialize when DOM is ready
const $9aa4113698f7fa9e$var$init = ()=>{
    // Clean up old states
    $9aa4113698f7fa9e$var$clearOldStates();
    // Try to restore state for all instances
    $9aa4113698f7fa9e$var$tryRestoreStates();
    // Setup state preservation for future navigation
    $9aa4113698f7fa9e$var$setupStatePreservation();
    // Initialize infinite scroll
    $9aa4113698f7fa9e$var$initInfiniteScroll();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $9aa4113698f7fa9e$var$init);
else $9aa4113698f7fa9e$var$init();
// Handle pageshow event for bfcache restoration
window.addEventListener('pageshow', (event)=>{
    if (event.persisted) $9aa4113698f7fa9e$var$tryRestoreStates();
});


/**
 *  Add data-toggle_modal="my-modal-id" to a button
 *  Add data-modal_id="my-modal-id" to an element
 *  An inner div is required in the modal element, see example below
 **/ let $c34fafc86f04ace2$var$modal, $c34fafc86f04ace2$var$overlay, $c34fafc86f04ace2$var$modalId, $c34fafc86f04ace2$var$closeBtn;
function $c34fafc86f04ace2$export$89f8829913472d51(modal) {
    $c34fafc86f04ace2$var$overlay = /*html*/ `<div class="overlay fixed inset-0 bg-black/25" data-toggle_modal="${$c34fafc86f04ace2$var$modalId}"></div>`;
    modal.insertAdjacentHTML('afterbegin', $c34fafc86f04ace2$var$overlay);
}
function $c34fafc86f04ace2$export$dd20ac38e791b8d0(modalBody) {
    $c34fafc86f04ace2$var$closeBtn = /*html*/ `<button class="close-btn absolute flex items-center justify-center size-10 duration-150 rounded-full right-3 hover:bg-black/5 active:bg-black/10 top-3" data-toggle_modal="${$c34fafc86f04ace2$var$modalId}">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
    </button>`;
    modalBody.insertAdjacentHTML('afterbegin', $c34fafc86f04ace2$var$closeBtn);
}
function $c34fafc86f04ace2$var$handleModal(e) {
    if (e.target.dataset.toggle_modal) {
        if ($c34fafc86f04ace2$var$modal && $c34fafc86f04ace2$var$modal.classList.contains('active')) {
            $c34fafc86f04ace2$var$modal.classList.remove('active');
            $c34fafc86f04ace2$var$modal.querySelector('.overlay').remove();
            $c34fafc86f04ace2$var$modal.querySelector('.close-btn').remove();
        } else {
            $c34fafc86f04ace2$var$modalId = e.target.dataset.toggle_modal;
            $c34fafc86f04ace2$var$modal = document.querySelector([
                `[data-modal_id="${$c34fafc86f04ace2$var$modalId}"]`
            ]);
            if (!$c34fafc86f04ace2$var$modal) return;
            const modalBody = $c34fafc86f04ace2$var$modal.querySelector('div:last-child');
            $c34fafc86f04ace2$export$89f8829913472d51($c34fafc86f04ace2$var$modal);
            $c34fafc86f04ace2$export$dd20ac38e791b8d0(modalBody);
            $c34fafc86f04ace2$var$modal.classList.toggle('active');
        }
    }
}
document.addEventListener('click', (e)=>{
    $c34fafc86f04ace2$var$handleModal(e);
});
document.addEventListener('keydown', (e)=>{
    if (e.key === 'Enter') $c34fafc86f04ace2$var$handleModal(e);
    if (e.key === 'Escape') {
        const activeModal = document.querySelector('[data-modal_id].active');
        if (activeModal) activeModal.classList.remove('active');
    }
}) /**
 * 
 * Example:
 * 
<button data-toggle_modal="login">Logga in</button>

<div class="flex items-center justify-center" data-modal_id="login">
    <div class="relative z-10 w-full max-w-lg p-4 bg-white rounded-lg md:p-6 lg:p-8">

    </div>
</div>
*/ ;


// Delade cookie-helpers. Tidigare reimplementerade både popup.js och
// latest-products.js var sin variant av get/setCookie — nu ligger den
// generiska logiken här.
/**
 * Sätt en cookie.
 * @param {string} name
 * @param {string} value  Råvärde (encoda själv om det kan innehålla ; eller ,).
 * @param {number} days   Antal dagar tills cookien går ut.
 */ const $aa7c3aec4e5384fe$export$110700823644f4a6 = (name, value, days)=>{
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${value};expires=${expires};path=/`;
};
const $aa7c3aec4e5384fe$export$4be65e66cfa2648a = (name)=>{
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
};


// Sets a cookie if user has already seen and closed the popup
const $7be597f098f5dfd6$var$setPopupCookie = (cookieName)=>{
    (0, $aa7c3aec4e5384fe$export$110700823644f4a6)(cookieName, 'closed', document.querySelector('.li-popup').getAttribute('data-popup_setcookie'));
};
// Checks if user has already seen and closed the popup
const $7be597f098f5dfd6$var$checkPopupCookie = (cookieName)=>{
    return (0, $aa7c3aec4e5384fe$export$4be65e66cfa2648a)(cookieName) !== 'closed';
};
// Closes the popup
const $7be597f098f5dfd6$var$closePopup = (popup)=>{
    popup.classList.remove('active');
    $7be597f098f5dfd6$var$setPopupCookie(popup.dataset.popup_name);
};
// Opens the popup if user hasn't already seen it after 5 seconds
const $7be597f098f5dfd6$var$openPopup = ()=>{
    const popup = document.querySelectorAll('.li-popup');
    if (!popup.length) return;
    popup.forEach((popup)=>{
        const delay = popup.dataset.popup_delay * 1000;
        setTimeout(()=>{
            if ($7be597f098f5dfd6$var$checkPopupCookie(popup.dataset.popup_name)) popup.classList.add('active');
        }, delay);
    });
};
// Closes the popup on close button
const $7be597f098f5dfd6$var$closePopupBtn = ()=>{
    const closeBtn = document.querySelectorAll('.close-li-popup');
    if (!closeBtn.length) return;
    closeBtn.forEach((closeBtn)=>{
        closeBtn.addEventListener('click', (e)=>$7be597f098f5dfd6$var$closePopup(e.target.closest('.li-popup')));
    });
};
// Closes the popup if user clicks outside
const $7be597f098f5dfd6$var$closePopupOutside = ()=>{
    const popup = document.querySelector('.li-popup:not(.no-close)');
    if (!popup) return;
    popup.addEventListener('click', (e)=>{
        if (e.target.classList.contains('li-popup')) $7be597f098f5dfd6$var$closePopup(popup);
    });
};
// Initialize the popup
const $7be597f098f5dfd6$var$initPopup = ()=>{
    $7be597f098f5dfd6$var$openPopup();
    $7be597f098f5dfd6$var$closePopupBtn();
    $7be597f098f5dfd6$var$closePopupOutside();
};
document.addEventListener('DOMContentLoaded', $7be597f098f5dfd6$var$initPopup);


// Butiksmeddelande – glider in nere till höger, försvinner efter
// data-duration sekunder. Visas en gång per session (sessionStorage)
// och kan stängas manuellt via kryss-knappen.
(function() {
    const SESSION_KEY = 'lw_shopmsg_shown';
    const FADE_OUT_MS = 300;
    document.addEventListener('DOMContentLoaded', ()=>{
        const el = document.querySelector('.lw-shopmsg');
        if (!el) return;
        if (sessionStorage.getItem(SESSION_KEY) === '1') {
            el.remove();
            return;
        }
        sessionStorage.setItem(SESSION_KEY, '1');
        const seconds = parseInt(el.dataset.duration, 10);
        const duration = (Number.isFinite(seconds) && seconds > 0 ? seconds : 5) * 1000;
        let autoHideTimer = null;
        const hide = ()=>{
            if (autoHideTimer) {
                clearTimeout(autoHideTimer);
                autoHideTimer = null;
            }
            el.classList.remove('active');
            setTimeout(()=>el.remove(), FADE_OUT_MS);
        };
        const progress = el.querySelector('.lw-shopmsg-progress');
        // Double rAF så CSS-transitionen hinner triggas
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                el.classList.add('active');
                if (progress) {
                    progress.style.transition = `transform ${duration}ms linear`;
                    progress.style.transform = 'scaleX(0)';
                }
            });
        });
        autoHideTimer = setTimeout(hide, duration);
        const closeBtn = el.querySelector('.lw-shopmsg-close');
        if (closeBtn) closeBtn.addEventListener('click', hide);
    });
})();


function $ae7d283db5dd77fd$var$handleYouTube() {
    // Ladda YouTube IFrame API
    var youtubePlayers = document.querySelectorAll('.video-player-wrapper[data-video-type="youtube"]');
    if (youtubePlayers.length === 0) return;
    if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    // Initieras när YouTube API är klart
    window.onYouTubeIframeAPIReady = function() {
        var youtubePlayers = document.querySelectorAll('.video-player-wrapper[data-video-type="youtube"]');
        youtubePlayers.forEach(function(playerWrapper) {
            var videoId = playerWrapper.getAttribute('data-video-id');
            var autoplay = parseInt(playerWrapper.getAttribute('data-video-autoplay'), 10);
            var controls = parseInt(playerWrapper.getAttribute('data-video-controls'), 10);
            // Skapa en div för YouTube-spelaren
            var playerDiv = document.createElement('div');
            playerWrapper.querySelector('.video-player').appendChild(playerDiv);
            // Initiera YouTube-spelaren
            var ytPlayer = new YT.Player(playerDiv, {
                height: '360',
                width: '640',
                videoId: videoId,
                playerVars: {
                    autoplay: 0,
                    controls: controls,
                    mute: autoplay,
                    loop: autoplay,
                    playlist: videoId,
                    modestbranding: 1,
                    playsinline: 1,
                    fs: 0,
                    cc_load_policy: 0,
                    iv_load_policy: 3,
                    autohide: autoplay
                },
                events: {
                    onReady: function(event) {
                        // Använd IntersectionObserver för att starta videon när den är i viewport
                        if (autoplay) {
                            var observer = new IntersectionObserver(function(entries, obs) {
                                entries.forEach(function(entry) {
                                    if (entry.isIntersecting) {
                                        event.target.playVideo() // Spela video
                                        ;
                                        obs.unobserve(entry.target) // Koppla bort observern
                                        ;
                                    }
                                });
                            }, {
                                threshold: 0.5
                            } // Justera tröskelvärdet efter behov
                            );
                            observer.observe(playerWrapper);
                            const playPause = playerWrapper.querySelector('.play-pause');
                            if (playPause) playPause.addEventListener('click', function() {
                                if (playPause.classList.contains('remove-play-pause')) {
                                    playPause.remove();
                                    event.target.seekTo(0);
                                    event.target.unMute();
                                    event.target.playVideo();
                                    return;
                                }
                                if (playPause.classList.contains('paused')) {
                                    playPause.classList.remove('paused');
                                    event.target.playVideo();
                                } else {
                                    playPause.classList.add('paused');
                                    event.target.pauseVideo();
                                }
                            });
                        }
                    }
                }
            });
        });
    };
}
function $ae7d283db5dd77fd$var$handleHTML5() {
    // Ladda HTML5-videospelaren
    var html5Players = document.querySelectorAll('.video-player-wrapper[data-video-type="html5"]');
    if (html5Players.length === 0) return;
    html5Players.forEach(function(playerWrapper) {
        const video = playerWrapper.querySelector('video');
        const playPause = playerWrapper.querySelector('.play-pause');
        if (playPause) playPause.addEventListener('click', function(event) {
            if (playPause.classList.contains('remove-play-pause')) {
                playPause.remove();
                video.currentTime = 0;
                video.muted = false;
                video.play();
                return;
            }
            if (playPause.classList.contains('paused')) {
                playPause.classList.remove('paused');
                video.play();
            } else {
                playPause.classList.add('paused');
                video.pause();
            }
        });
    });
}
function $ae7d283db5dd77fd$var$handleVimeo() {
    var vimeoPlayerWrappers = document.querySelectorAll('.video-player-wrapper[data-video-type="vimeo"]');
    if (vimeoPlayerWrappers.length === 0) return;
    var tag = document.createElement('script');
    tag.src = 'https://player.vimeo.com/api/player.js';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    tag.onload = function() {
        vimeoPlayerWrappers.forEach(function(playerWrapper) {
            var videoId = playerWrapper.getAttribute('data-video-id');
            var autoplay = parseInt(playerWrapper.getAttribute('data-video-autoplay'), 10);
            var controls = parseInt(playerWrapper.getAttribute('data-video-controls'), 10);
            const playerDiv = playerWrapper.querySelector('.video-player');
            const vimeoPlayer = new Vimeo.Player(playerDiv, {
                id: videoId,
                autoplay: 0,
                controls: controls,
                muted: autoplay,
                loop: autoplay
            });
            if (autoplay) {
                var observer = new IntersectionObserver(function(entries, obs) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            vimeoPlayer.play();
                            obs.unobserve(entry.target);
                        }
                    });
                }, {
                    threshold: 0.5
                });
                observer.observe(playerWrapper);
            }
            vimeoPlayer.on('play', function() {
                playerWrapper.classList.add('video-activated');
            });
            vimeoPlayer.on('pause', function() {
                playerWrapper.classList.remove('video-activated');
            });
            const playPause = playerWrapper.querySelector('.play-pause');
            if (playPause) playPause.addEventListener('click', function() {
                vimeoPlayer.getPaused().then(function(paused) {
                    if (playPause.classList.contains('remove-play-pause')) {
                        playPause.remove();
                        vimeoPlayer.setCurrentTime(0);
                        vimeoPlayer.setVolume(1);
                        vimeoPlayer.play();
                        return;
                    }
                    if (paused) {
                        playPause.classList.remove('paused');
                        vimeoPlayer.play();
                    } else {
                        playPause.classList.add('paused');
                        vimeoPlayer.pause();
                    }
                });
            });
        });
    };
}
document.addEventListener('DOMContentLoaded', function() {
    $ae7d283db5dd77fd$var$handleYouTube();
    $ae7d283db5dd77fd$var$handleHTML5();
    $ae7d283db5dd77fd$var$handleVimeo();
});


document.addEventListener('DOMContentLoaded', ()=>{
    const previewText = /*html*/ `
    <span class="absolute -top-1.5 left-0 right-0 inline-flex items-center justify-center px-3 py-2 mx-auto text-sm text-center text-black rounded-sm max-w-96 bg-[#FBF13C]/90 hover:opacity-20 transition-opacity z-10">
        <span class="inline-flex items-center justify-center p-1 mr-2 text-sm bg-white rounded-full sm:mr-3 size-5">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="#000000" />
            </svg>
        </span>
        <strong class="mr-1">F\xf6rhandsgranskning</strong> - visas endast f\xf6r admin &darr;
    </span>`;
    const previewComponents = document.querySelectorAll('[data-preview]');
    if (previewComponents.length > 0) previewComponents.forEach((component)=>{
        component.insertAdjacentHTML('beforeend', previewText);
    });
});


document.addEventListener('click', (e)=>{
    if (e.target.dataset.stepNext) {
        const step = e.target.dataset.stepNext;
        const stepElement = document.querySelector(`[data-step="${step}"]`);
        stepElement.open = true;
        const rect = stepElement.getBoundingClientRect();
        window.scrollTo({
            top: window.scrollY + rect.top - 160,
            behavior: 'smooth'
        });
    }
});



const $d9bbb5e2b12cf194$var$mainMenu = document.querySelector('#main-menu');
const $d9bbb5e2b12cf194$var$menuToggleBtn = document.querySelector('.main-menu-toggle-btn');
/**
 * Sätt --menu-index på varje toppnivårad så CSS kan trappa animationsstarten.
 */ document.querySelectorAll('#primary-menu .parent-item').forEach((item, i)=>{
    item.style.setProperty('--menu-index', i);
});
function $d9bbb5e2b12cf194$var$toggleMenu() {
    (0, $b08b64811b3a177f$export$dd4db7a8de9ade16)();
    $d9bbb5e2b12cf194$var$mainMenu.classList.toggle('flex!');
    if ($d9bbb5e2b12cf194$var$menuToggleBtn.classList.contains('menu-toggled')) $d9bbb5e2b12cf194$var$menuToggleBtn.classList.remove('menu-toggled');
    else $d9bbb5e2b12cf194$var$menuToggleBtn.classList.add('menu-toggled');
}
function $d9bbb5e2b12cf194$export$69ff42680518db68() {
    $d9bbb5e2b12cf194$var$mainMenu.classList.remove('flex!');
    $d9bbb5e2b12cf194$var$menuToggleBtn.classList.remove('menu-toggled');
}
let $d9bbb5e2b12cf194$var$dropdownBtn, $d9bbb5e2b12cf194$var$dropdown;
document.addEventListener('click', function(e) {
    if (e.target.closest('.main-menu-toggle-btn')) $d9bbb5e2b12cf194$var$toggleMenu();
    // if clicking outside of dropdown menu and dropdown menu is open then close it
    if ($d9bbb5e2b12cf194$var$dropdown && e.target !== $d9bbb5e2b12cf194$var$dropdown && !$d9bbb5e2b12cf194$var$dropdown.contains(e.target)) {
        $d9bbb5e2b12cf194$var$dropdownBtn.classList.remove('pointer-events-none');
        $d9bbb5e2b12cf194$var$dropdown.classList.remove('block!');
    }
    if (e.target.classList.contains('dropdown-btn')) {
        $d9bbb5e2b12cf194$var$dropdownBtn = e.target;
        $d9bbb5e2b12cf194$var$mainMenu.classList.remove('flex!');
        $d9bbb5e2b12cf194$var$menuToggleBtn.classList.remove('menu-toggled');
        $d9bbb5e2b12cf194$var$dropdown = e.target.closest('.dropdown-btn').nextElementSibling;
        if ($d9bbb5e2b12cf194$var$dropdown.classList.contains('block!')) $d9bbb5e2b12cf194$var$dropdown.classList.remove('block!');
        else {
            $d9bbb5e2b12cf194$var$dropdownBtn.classList.add('pointer-events-none');
            $d9bbb5e2b12cf194$var$dropdown.classList.add('block!');
        }
    }
    if (e.target.classList.contains('sub-menu-toggle-button')) {
        const parent = e.target.closest('.menu-item-has-children');
        const submenu = parent.querySelector('.sub-menu');
        if (submenu.classList.contains('active')) {
            submenu.classList.remove('active');
            parent.classList.remove('active');
        } else {
            submenu.classList.add('active');
            parent.classList.add('active');
        }
    }
});
// remove submenu_classes from submenu when window is resized, only once
const $d9bbb5e2b12cf194$var$submenus = document.querySelectorAll('.sub-menu');
let $d9bbb5e2b12cf194$var$resized = false;
window.addEventListener('resize', function() {
    if (window.innerWidth > 1024) {
        if ($d9bbb5e2b12cf194$var$resized) return;
        $d9bbb5e2b12cf194$var$submenus.forEach((submenu)=>submenu.classList.remove('active'));
        $d9bbb5e2b12cf194$var$resized = true;
    } else {
        if (!$d9bbb5e2b12cf194$var$resized) return;
        $d9bbb5e2b12cf194$var$submenus.forEach((submenu)=>submenu.classList.remove('active'));
        $d9bbb5e2b12cf194$var$resized = false;
    }
});


const $b08b64811b3a177f$var$searchWrapper = document.querySelector('.site-search-wrapper');
const $b08b64811b3a177f$var$searchInput = $b08b64811b3a177f$var$searchWrapper.querySelector('.main-search-input');
function $b08b64811b3a177f$export$dd4db7a8de9ade16() {
    $b08b64811b3a177f$var$searchInput.value = '';
    $b08b64811b3a177f$var$searchWrapper.classList.remove('block!');
    return;
}
function $b08b64811b3a177f$var$toggleSearchRecommendations() {
    console.log('toggleSearchRecommendations');
    const searchResults = document.querySelector('.relevanssi-live-search-results');
    const searchRecommendations = document.querySelector('#recommended-search-results');
    if (!searchResults || !searchRecommendations) return;
    if (searchResults.classList.contains('relevanssi-live-search-results-showing')) searchRecommendations.classList.add('hidden!');
    else searchRecommendations.classList.remove('hidden!');
}
document.addEventListener('click', function(e) {
    // Search toggle
    if (e.target.classList.contains('search-toggle')) {
        $b08b64811b3a177f$var$searchWrapper.classList.toggle('block!');
        (0, $d9bbb5e2b12cf194$export$69ff42680518db68)();
        $b08b64811b3a177f$var$searchInput.focus();
    }
    if (e.target.classList.contains('search-overlay') || e.target.classList.contains('close-search')) $b08b64811b3a177f$export$dd4db7a8de9ade16();
});
document.addEventListener('keyup', function(e) {
    if (e.target.classList.contains('main-search-input')) {
        if (e.key === 'Escape') $b08b64811b3a177f$export$dd4db7a8de9ade16();
        $b08b64811b3a177f$var$toggleSearchRecommendations();
    }
});


/**
 * Lazy-laddare för Swiper.
 *
 * Dynamisk import() lägger Swiper i en egen chunk som hämtas först när ett
 * slider-element finns i DOM — används av pc-products, pc-product-cats,
 * pc-post-listing och pc-gallery. Promisen memoiseras så att sliders.js och
 * gallery.js delar samma chunk och samma nedladdning.
 */ let $faf8d030e16db4d3$var$swiperPromise = null;


function $faf8d030e16db4d3$export$b9e0a27382fdbe4f() {
    if (!$faf8d030e16db4d3$var$swiperPromise) $faf8d030e16db4d3$var$swiperPromise = Promise.all([
        (parcelRequire("djrMl")),
        (parcelRequire("fY4Cn"))
    ]).then(([core, modules])=>({
            Swiper: core.default,
            ...modules
        }));
    return $faf8d030e16db4d3$var$swiperPromise;
}


// Sätts av loadSwiper() innan någon slider instansieras.
let $382dd2a1c0fca85d$var$Swiper, $382dd2a1c0fca85d$var$Navigation, $382dd2a1c0fca85d$var$Scrollbar, $382dd2a1c0fca85d$var$Autoplay, $382dd2a1c0fca85d$var$EffectFade;
function $382dd2a1c0fca85d$var$buildOptions(swiperCarousel) {
    const options = {
        modules: [
            $382dd2a1c0fca85d$var$Navigation,
            $382dd2a1c0fca85d$var$Scrollbar,
            $382dd2a1c0fca85d$var$Autoplay
        ],
        navigation: {
            nextEl: swiperCarousel.parentElement.querySelector('.swiper-button-next'),
            prevEl: swiperCarousel.parentElement.querySelector('.swiper-button-prev')
        },
        scrollbar: {
            el: swiperCarousel.parentElement.querySelector('.swiper-scrollbar'),
            draggable: true
        },
        speed: 500
    };
    if (swiperCarousel.dataset.slider_breakpoints) try {
        options.breakpoints = JSON.parse(swiperCarousel.dataset.slider_breakpoints);
    } catch (err) {
        console.error('Invalid data-slider_breakpoints JSON', err, swiperCarousel);
    }
    if (swiperCarousel.dataset.slider_autoplay === 'true') {
        options.autoplay = {
            delay: 0,
            reverseDirection: swiperCarousel.dataset.slider_autoplay_direction === 'reverse'
        };
        options.loop = true;
        options.speed = 4000;
        if (swiperCarousel.dataset.slider_autoplay_delay) {
            options.autoplay.delay = parseInt(swiperCarousel.dataset.slider_autoplay_delay, 10);
            options.speed = 300;
        }
    }
    if (swiperCarousel.dataset.fade === 'true') {
        options.modules.push($382dd2a1c0fca85d$var$EffectFade);
        options.effect = 'fade';
        options.fadeEffect = {
            crossFade: true
        };
    }
    return options;
}
function $382dd2a1c0fca85d$var$setupMobileOnlySwiper(swiperCarousel) {
    const breakpoint = parseInt(swiperCarousel.dataset.slider_mobile_breakpoint, 10) || 768;
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const wrapper = swiperCarousel.firstElementChild;
    if (!wrapper) return;
    const slides = Array.from(wrapper.children);
    const addSwiperClasses = ()=>{
        wrapper.classList.add('swiper-wrapper');
        slides.forEach((slide)=>slide.classList.add('swiper-slide'));
    };
    const removeSwiperClasses = ()=>{
        wrapper.classList.remove('swiper-wrapper');
        slides.forEach((slide)=>slide.classList.remove('swiper-slide'));
    };
    const sync = ()=>{
        if (mediaQuery.matches) {
            if (!swiperCarousel.swiper) {
                addSwiperClasses();
                swiperCarousel.swiper = new $382dd2a1c0fca85d$var$Swiper(swiperCarousel, $382dd2a1c0fca85d$var$buildOptions(swiperCarousel));
            }
        } else {
            if (swiperCarousel.swiper) {
                swiperCarousel.swiper.destroy(true, true);
                swiperCarousel.swiper = null;
            }
            removeSwiperClasses();
        }
    };
    sync();
    mediaQuery.addEventListener('change', sync);
}
async function $382dd2a1c0fca85d$var$initSwiperCarousels() {
    const swiperCarousels = document.querySelectorAll('.swiper-carousel');
    // Ingen slider på sidan = Swiper-chunken hämtas aldrig.
    if (!swiperCarousels.length) return;
    ({ Swiper: $382dd2a1c0fca85d$var$Swiper, Navigation: $382dd2a1c0fca85d$var$Navigation, Scrollbar: $382dd2a1c0fca85d$var$Scrollbar, Autoplay: $382dd2a1c0fca85d$var$Autoplay, EffectFade: $382dd2a1c0fca85d$var$EffectFade } = await (0, $faf8d030e16db4d3$export$b9e0a27382fdbe4f)());
    swiperCarousels.forEach((swiperCarousel)=>{
        if (swiperCarousel.dataset.slider_mobile_only === 'true') {
            $382dd2a1c0fca85d$var$setupMobileOnlySwiper(swiperCarousel);
            return;
        }
        swiperCarousel.swiper = new $382dd2a1c0fca85d$var$Swiper(swiperCarousel, $382dd2a1c0fca85d$var$buildOptions(swiperCarousel));
    });
}
$382dd2a1c0fca85d$var$initSwiperCarousels();



const $c001ddf96774b03f$export$becb836e43488847 = ()=>{
    // Target all input containers from all Gravity Forms
    const inputContainers = document.getElementsByClassName('ginput_container');
    if (inputContainers.length) // Setup focus and blur events for each field
    for (const inputContainer of inputContainers){
        // Target input element in container, whether it's an input or a textarea
        const inputElement = inputContainer.querySelectorAll(":scope > *")[0];
        // Label element is always the previous sibling of the input container
        const labelElement = inputContainer.previousElementSibling;
        // Activate label if input has value - this moves the label above the input
        inputElement.addEventListener('focus', (event)=>{
            labelElement.classList.add('active');
        });
        // Deactivate label if input is empty on blur - this moves the label back to its original position
        inputElement.addEventListener('blur-sm', (event)=>{
            if (inputElement.value === '') labelElement.classList.remove('active');
        });
        // If the input has a value on page load (when user submit fails) then activate the label
        // Also prevent animation to avoid flicker
        if (inputElement.value !== '') {
            labelElement.classList.add('no-animation');
            labelElement.classList.add('active');
            setTimeout(()=>{
                labelElement.classList.remove('no-animation');
            }, 200);
        }
    }
};
document.addEventListener('DOMContentLoaded', function() {
    // Have to use jQuery here because the gform_post_render event is triggered by Gravity Forms
    // This fires on page load and on submit.
    jQuery(document).on('gform_post_render', function(event, form_id, current_page) {
        // Move validation error message to bottom of form
        jQuery(`#gform_wrapper_${form_id} div.gform_validation_errors`).appendTo(`#gform_${form_id} div.gform_body`);
        $c001ddf96774b03f$export$becb836e43488847();
    });
}, false);


/**
 * Hero-video
 *
 * Två saker:
 *  1. Väljer rätt videofil för viewporten. <video> stödjer inte
 *     media-attributet på <source> i praktiken (Chrome och Firefox
 *     ignorerar det), så källorna skickas som data-attribut från PHP och
 *     väljs här istället.
 *  2. Startar/stoppar originalvideon i "Se videon"-modalen. modal.js
 *     togglar bara klassen `active`, så vi lyssnar på den.
 */ // Måste matcha --breakpoint-* i src/css/theme.css.
const $7533733764d69c0d$var$BREAKPOINTS = [
    {
        key: 'base',
        min: 0
    },
    {
        key: 'sm',
        min: 640
    },
    {
        key: 'md',
        min: 768
    },
    {
        key: 'lg',
        min: 1024
    },
    {
        key: 'xl',
        min: 1280
    }
];
const $7533733764d69c0d$var$RESIZE_DEBOUNCE = 200;
/**
 * Närmast större fil först (bättre kvalitet), sedan originalet, sist
 * närmast mindre. Alla brytpunkter är valfria i admin.
 */ function $7533733764d69c0d$var$pickSource(video) {
    const width = window.innerWidth;
    let current = 0;
    $7533733764d69c0d$var$BREAKPOINTS.forEach((bp, i)=>{
        if (width >= bp.min) current = i;
    });
    for(let i = current; i < $7533733764d69c0d$var$BREAKPOINTS.length; i++){
        const src = video.getAttribute(`data-src-${$7533733764d69c0d$var$BREAKPOINTS[i].key}`);
        if (src) return src;
    }
    const original = video.getAttribute('data-src-original');
    if (original) return original;
    for(let i = current - 1; i >= 0; i--){
        const src = video.getAttribute(`data-src-${$7533733764d69c0d$var$BREAKPOINTS[i].key}`);
        if (src) return src;
    }
    return '';
}
function $7533733764d69c0d$var$applySource(video) {
    const src = $7533733764d69c0d$var$pickSource(video);
    if (!src || video.dataset.currentSrc === src) return;
    const time = video.currentTime;
    const shouldPlay = video.autoplay || !video.paused;
    video.dataset.currentSrc = src;
    video.src = src;
    video.load();
    if (time > 0) // Behåll uppspelningsläget vid byte, t.ex. när en laptop dockas
    // mot en extern skärm.
    video.addEventListener('loadedmetadata', ()=>{
        if (time < video.duration) video.currentTime = time;
    }, {
        once: true
    });
    // preload="none" i markup gör att inget hämtas förrän vi ber om det,
    // så uppspelningen måste startas explicit — vi kan inte vänta på
    // loadedmetadata eftersom den då aldrig hinner triggas.
    if (shouldPlay) video.play().catch(()=>{});
}
function $7533733764d69c0d$var$initResponsiveVideos() {
    const videos = document.querySelectorAll('[data-hero-video]');
    if (!videos.length) return;
    videos.forEach((video)=>{
        video.dataset.currentSrc = video.getAttribute('src') || '';
        $7533733764d69c0d$var$applySource(video);
    });
    let timer;
    window.addEventListener('resize', ()=>{
        clearTimeout(timer);
        timer = setTimeout(()=>videos.forEach($7533733764d69c0d$var$applySource), $7533733764d69c0d$var$RESIZE_DEBOUNCE);
    });
}
function $7533733764d69c0d$var$initModals() {
    const modals = document.querySelectorAll('.hero-video-modal');
    if (!modals.length) return;
    modals.forEach((modal)=>{
        const modalVideo = modal.querySelector('[data-hero-modal-video]');
        if (!modalVideo) return;
        const bgVideo = modal.closest('section')?.querySelector('video.hero-bg-img');
        const observer = new MutationObserver(()=>{
            if (modal.classList.contains('active')) {
                bgVideo?.pause();
                modalVideo.play().catch(()=>{});
            } else {
                modalVideo.pause();
                modalVideo.currentTime = 0;
                if (bgVideo?.autoplay) bgVideo.play().catch(()=>{});
            }
        });
        observer.observe(modal, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    $7533733764d69c0d$var$initResponsiveVideos();
    $7533733764d69c0d$var$initModals();
});


document.addEventListener('DOMContentLoaded', function() {
    const stickyMenu = document.querySelector('.pc-sticky-menu');
    const masthead = document.querySelector('#masthead');
    if (!stickyMenu || !masthead) return;
    const updateStickyMenu = ()=>{
        const mastheadHeight = masthead.offsetHeight;
        if (stickyMenu.style.top !== `${mastheadHeight}px`) stickyMenu.style.top = `${mastheadHeight}px`;
    };
    updateStickyMenu();
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateStickyMenu, 100);
    });
});


document.addEventListener('click', (e)=>{
    if (e.target.closest('.cat-filter')) {
        const catFilters = document.querySelectorAll('.cat-filter');
        catFilters.forEach((catFilter)=>catFilter.classList.remove('active'));
        const catFilter = e.target.closest('.cat-filter');
        const filterValue = catFilter.dataset.value;
        const postListing = catFilter.closest('.pc-post-listing');
        const postContainer = postListing.querySelector('.post-listing');
        const loadMoreBtn = postListing.querySelector('.load-more');
        if (loadMoreBtn) {
            loadMoreBtnText = loadMoreBtn.querySelector('.load-more-text');
            loadMoreBtn.dataset.catId = filterValue;
        }
        const data = new FormData();
        data.append('action', 'load_more');
        data.append('security', liGlobal.loadMore);
        data.append('cat_id', filterValue);
        data.append('post_type', 'post');
        // Listningens fasta kategoriurval. Måste med även här — annars visar
        // "Alla" hela bloggen i stället för bara de valda kategorierna.
        const listingCategories = catFilter.closest('[data-listing-categories]')?.dataset.listingCategories || '';
        if (listingCategories) data.append('categories', listingCategories);
        if (loadMoreBtn) {
            data.append('card_class', loadMoreBtn.dataset.cardClass);
            data.append('card_body', loadMoreBtn.dataset.cardBody);
        }
        fetch(liGlobal.ajaxUrl, {
            method: 'POST',
            body: data
        }).then((response)=>response.text()).then((response)=>{
            response = JSON.parse(response);
            if (!response.success) return;
            catFilter.classList.add('active');
            if (loadMoreBtn) {
                // Listan byggs om från början — nollställ pagineringen, annars
                // tror knappen att den redan står på sidan den stod på före bytet.
                loadMoreBtn.dataset.paged = '1';
                loadMoreBtn.dataset.maxPages = response.data.max_num_pages?.toString() || '';
                // Läs flaggan, inte texten: texten kommer på svenska från PHP
                // och den gamla jämförelsen mot 'No more posts' slog aldrig till.
                const noMore = response.data.no_more_posts || response.data.max_num_pages <= 1;
                if (noMore) {
                    loadMoreBtn.setAttribute('disabled', 'disabled');
                    loadMoreBtn.classList.remove('loading');
                    loadMoreBtn.style.display = 'none';
                } else {
                    loadMoreBtn.removeAttribute('disabled');
                    loadMoreBtn.style.display = '';
                }
                loadMoreBtnText.textContent = response.data.load_more_btn_text;
            }
            const posts = response.data.posts;
            postContainer.innerHTML = '';
            posts.forEach((post)=>{
                postContainer.insertAdjacentHTML('beforeend', post);
            });
        });
    }
});



async function $5e35a2fda4e05f32$var$initGallerySliders() {
    const gallerySliders = document.querySelectorAll('.gallery-slider');
    // Ingen galleri-slider på sidan = Swiper-chunken hämtas aldrig.
    if (!gallerySliders.length) return;
    const { Swiper: Swiper, Navigation: Navigation, HashNavigation: HashNavigation, Keyboard: Keyboard } = await (0, $faf8d030e16db4d3$export$b9e0a27382fdbe4f)();
    gallerySliders.forEach((gallerySlider)=>{
        new Swiper(gallerySlider, {
            modules: [
                Navigation,
                HashNavigation,
                Keyboard
            ],
            loop: true,
            keyboard: {
                enabled: true
            },
            hashNavigation: {
                watchState: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    });
}
document.addEventListener('DOMContentLoaded', $5e35a2fda4e05f32$var$initGallerySliders);
function $5e35a2fda4e05f32$var$toggleGallery(openGalleryButton, event) {
    const gallery = openGalleryButton.closest('.gallery');
    const gallerySliderModal = gallery.querySelector('.gallery-slider-modal');
    if (event === 'open') gallerySliderModal.classList.add('active');
    else gallerySliderModal.classList.remove('active');
}
document.addEventListener('click', (e)=>{
    if (e.target.closest('.open-gallery')) {
        const openGalleryButton = e.target.closest('.open-gallery');
        $5e35a2fda4e05f32$var$toggleGallery(openGalleryButton, 'open');
    }
    if (e.target.closest('.close-gallery')) {
        const closeGalleryButton = e.target.closest('.close-gallery');
        $5e35a2fda4e05f32$var$toggleGallery(closeGalleryButton, 'close');
    }
});
document.addEventListener('keydown', (e)=>{
    if (e.key === 'Escape') {
        const gallerySliderModals = document.querySelectorAll('.gallery-slider-modal');
        gallerySliderModals.forEach((gallerySliderModal)=>{
            gallerySliderModal.classList.remove('active');
        });
    }
});


// Växlar visningen av minicart (öppna/stäng)
function $609a23232a2c91c9$export$b80ba46938a066f3() {
    const miniCartWrapper = document.querySelector('#mini-cart-dropdown').parentElement;
    if (document.body.classList.contains('mini-cart-open')) {
        miniCartWrapper.classList.remove('active');
        document.body.classList.remove('mini-cart-open');
    } else {
        miniCartWrapper.classList.add('active');
        document.body.classList.add('mini-cart-open');
    }
}
document.addEventListener('click', function(e) {
    if (e.target.closest('.cart-toggle-btn')) $609a23232a2c91c9$export$b80ba46938a066f3();
});
// Läser ut ett enskilt värde ur document.cookie.
function $609a23232a2c91c9$var$lwCookieValue(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
}
function $609a23232a2c91c9$var$lwWcAjaxUrl(endpoint) {
    const tpl = window.wc_add_to_cart_params?.wc_ajax_url || '/?wc-ajax=%%endpoint%%';
    return tpl.replace('%%endpoint%%', endpoint);
}
jQuery(function($) {
    // Var felrutan för ett misslyckat köp ska hamna: sist i produktformuläret
    // (enskild produkt) respektive i loop-wrappern — alltid i anslutning till
    // knappen man just tryckte på.
    function addToCartErrorHost(button) {
        var $host = button.closest('form.cart');
        if (!$host.length) $host = button.closest('.lw-loop-add-to-cart');
        if (!$host.length) $host = button.parent();
        return $host;
    }
    function clearAddToCartError(button) {
        addToCartErrorHost(button).find('.lw-atc-error').remove();
    }
    function showAddToCartError(button, html) {
        clearAddToCartError(button);
        $('<div class="lw-atc-error"></div>').html(html).appendTo(addToCartErrorHost(button));
    }
    function refreshMiniCart() {
        $.ajax({
            url: $609a23232a2c91c9$var$lwWcAjaxUrl('get_refreshed_fragments'),
            type: 'POST',
            beforeSend: function() {
                $(document.body).trigger('wc_fragment_refresh');
            },
            success: function(data) {
                if (!data.fragments) return;
                $.each(data.fragments, function(selector, html) {
                    $(selector).html(html);
                });
                var hasItems = data.fragments.total_count > 0;
                $('.checkout-button').toggleClass('disabled', !hasItems);
                $('#lw-share-cart-btn').toggleClass('hidden', !hasItems);
                // Containern bär serverns varukorgshash från sidladdningen.
                // Skriv om den till det som nu ligger i sessionen, annars tror
                // en senare kontroll att markupen fortfarande är inaktuell.
                $('#mini-cart-dropdown').attr('data-cart-hash', hasItems ? data.cart_hash || '' : '');
                $(document.body).trigger('wc_fragments_refreshed', [
                    data.fragments
                ]);
                $(document.body).trigger('wc_fragments_loaded', [
                    data.fragments
                ]);
                $(document.body).trigger('cart_totals_refreshed');
            },
            error: function() {
                $(document.body).trigger('wc_fragments_ajax_error');
            }
        });
    }
    $(document).on('click', '.single_add_to_cart_button, .product_type_simple.add_to_cart_button', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $form = $(this).closest('form.cart');
        var button = $(this);
        // Handlern kapar klicket med stopImmediatePropagation, så WC:s egna
        // spärrar hinner aldrig säga ifrån. Respektera därför disabled-läget
        // själva — annars skickas ett köp som servern ändå avvisar.
        //
        // Enbart propertyn, INTE .disabled-klassen: WC låter klassen ligga kvar
        // på knappen även när en giltig variant är vald, så en klasskontroll
        // hade blockerat helt legitima köp. Propertyn för en ej köpbar variant
        // (slut i lager) sätts i out-of-stock.js.
        if (button.prop('disabled')) return;
        var formData = $form.length ? new FormData($form[0]) : new FormData();
        // Variabel produkt utan vald variant: servern kan inte lägga något i
        // varukorgen, den skulle bara lägga en "Välj produktalternativ"-notis i
        // sessionen som dyker upp på nästa sidvisning (typiskt kassan). Skicka
        // inget — WC:s egen variantvalidering visar återkopplingen på plats.
        if ($form.length && $form.hasClass('variations_form') && !parseInt(formData.get('variation_id'), 10)) return;
        // Build payload from wrapper + selected variation
        if (!$form.length) {
            var $wrap = button.closest('.lw-loop-add-to-cart');
            if ($wrap.length) {
                var productId = $wrap.data('product-id');
                var variationId = $wrap.attr('data-selected-variation-id');
                var attrsJson = $wrap.attr('data-selected-attrs') || '{}';
                if (!productId || !variationId) // no selected variation -> do nothing
                return;
                formData.set('product_id', productId);
                formData.set('variation_id', variationId);
                formData.set('quantity', '1');
                // also send add-to-cart (some setups like it)
                formData.set('add-to-cart', productId);
                try {
                    var attrs = JSON.parse(attrsJson);
                    Object.keys(attrs || {}).forEach(function(k) {
                        formData.set(k, attrs[k]);
                    });
                } catch (err) {
                // ignore JSON-fel
                }
            }
        }
        // Befintlig fallback: om simple saknar add-to-cart/product_id
        if (!formData.get('product_id') && !formData.get('add-to-cart')) {
            var productId = button.val() || button.data('product_id') || button.attr('data-product_id') || $form.find('input[name="add-to-cart"]').val();
            if (productId) formData.set('add-to-cart', productId);
        }
        if (!button.hasClass('cs_add_to_cart_button')) button.text(liGlobal.addingToCartText);
        clearAddToCartError(button);
        $(document.body).trigger('adding_to_cart', [
            button,
            formData
        ]);
        // OBS: endpointen är get_refreshed_fragments, INTE add_to_cart.
        //
        // WC_AJAX::add_to_cart() anropar WC()->cart->add_to_cart($product_id, $qty)
        // utan variation_id och klarar därför bara enkla produkter. För en variant
        // kastade den "Välj produktalternativ genom att besöka …" som en
        // error-notis i sessionen — den dök sedan upp på nästa sidvisning, typiskt
        // kassan, trots att varianten låg korrekt i varukorgen.
        //
        // Att den ändå hamnade rätt beror på att payloaden innehåller
        // `add-to-cart`, vilket får WC_Form_Handler::add_to_cart_action() att köra
        // på wp_loaded — den hanterar variation_id och attribut korrekt. Det är
        // alltså den vägen som gör jobbet, och add_to_cart-endpointen lade bara
        // till ett andra, dömt försök.
        //
        // Med get_refreshed_fragments körs formulärhanteraren på wp_loaded och
        // fragmenten byggs efteråt på template_redirect — samma svarsformat
        // ({fragments, cart_hash}) som success-callbacken redan förväntar sig.
        $.ajax({
            url: $609a23232a2c91c9$var$lwWcAjaxUrl('get_refreshed_fragments'),
            method: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            success: function(data) {
                var fragments = data && data.fragments ? data.fragments : null;
                var cartHash = data && data.cart_hash ? data.cart_hash : null;
                // Misslyckat köp (slut i lager, ej köpbar variant, plugin-
                // validering): felen kommer med i svaret i stället för att ligga
                // kvar i sessionen och dyka upp på nästa sidvisning — se
                // includes/woocommerce/action-functions/minicart/lw_minicart_add_to_cart_notices.php.
                // Visa dem vid knappen och låt bli att öppna minivarukorgen, som
                // annars glider upp som om något hade lagts till.
                var errorHtml = fragments ? fragments.lw_atc_notices : '';
                if (errorHtml) {
                    showAddToCartError(button, errorHtml);
                    if (!button.hasClass('cs_add_to_cart_button')) button.text(liGlobal.addToCartText);
                    $(document.body).trigger('wc_add_to_cart_error', [
                        button
                    ]);
                    return;
                }
                $(document.body).trigger('added_to_cart', [
                    fragments,
                    cartHash,
                    button
                ]);
                $(document.body).trigger('wc_cart_button_updated', [
                    button
                ]);
                refreshMiniCart();
                setTimeout(()=>{
                    $609a23232a2c91c9$export$b80ba46938a066f3();
                    if (!button.hasClass('cs_add_to_cart_button')) button.text(liGlobal.addToCartText);
                }, 500);
            },
            error: function() {
                $(document.body).trigger('wc_add_to_cart_error', [
                    button
                ]);
                if (!button.hasClass('cs_add_to_cart_button')) button.text(liGlobal.addToCartText);
            }
        });
    });
    // Cross-sells "Lägg till"-knapp för enkla produkter i mini-cart. Använder WC:s
    // add_to_cart wc-ajax-endpoint men avbryter event så den yttre <a> inte navigerar
    // och den generiska add-to-cart-handlern (som stänger mini-carten) inte triggar.
    // Vi refreshar bara fragmenten så mini-carten hålls öppen.
    $(document).on('click', '.lw-minicart-cross-sell-add', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const btn = $(this);
        const productId = btn.data('product-id');
        if (!productId) return;
        if (btn.prop('disabled')) return;
        const originalText = btn.text();
        btn.prop('disabled', true);
        if (window.liGlobal?.addingToCartText) btn.text(window.liGlobal.addingToCartText);
        $.ajax({
            url: $609a23232a2c91c9$var$lwWcAjaxUrl('add_to_cart'),
            method: 'POST',
            data: {
                product_id: productId,
                quantity: 1
            },
            success: function(data) {
                const fragments = data && data.fragments ? data.fragments : null;
                const cartHash = data && data.cart_hash ? data.cart_hash : null;
                $(document.body).trigger('added_to_cart', [
                    fragments,
                    cartHash,
                    btn
                ]);
                refreshMiniCart();
            },
            complete: function() {
                btn.prop('disabled', false);
                btn.text(originalText);
            }
        });
    });
    // +/-
    $(document).on('click', '.qty-plus', function() {
        const input = $(this).siblings('.mini-qty');
        const newQty = parseInt(input.val(), 10) + 1;
        input.val(newQty).trigger('change');
    });
    $(document).on('click', '.qty-minus', function() {
        const input = $(this).siblings('.mini-qty');
        const minQty = parseInt(input.data('min-qty'), 10) || 1;
        const newQty = Math.max(minQty, parseInt(input.val(), 10) - 1);
        input.val(newQty).trigger('change');
    });
    $(document).on('change', '.mini-qty', function() {
        const key = $(this).data('cart-item-key');
        const qty = $(this).val();
        $.ajax({
            url: liGlobal.ajaxUrl,
            method: 'POST',
            data: {
                action: 'lw_update_mini_cart_qty',
                cart_item_key: key,
                quantity: qty
            },
            beforeSend: function() {
                $(document.body).trigger('update_cart_totals');
            },
            success: function(resp) {
                if (resp && resp.success) {
                    refreshMiniCart();
                    $(document.body).trigger('updated_cart_totals');
                    $(document.body).trigger('cart_totals_refreshed');
                }
            }
        });
    });
    // Sidan kan levereras ur LiteSpeeds publika sidcache och bär då den
    // varukorg som gällde när kopian skapades. WooCommerce sätter cookien
    // woocommerce_cart_hash till samma värde som servern renderar i
    // data-cart-hash. Skiljer de sig är markupen inaktuell och fragmenten
    // hämtas om — är de lika görs inget anrop.
    function syncMiniCartFromSession() {
        const dropdown = document.getElementById('mini-cart-dropdown');
        if (!dropdown) return;
        if ($609a23232a2c91c9$var$lwCookieValue('woocommerce_cart_hash') === (dropdown.getAttribute('data-cart-hash') || '')) return;
        refreshMiniCart();
    }
    syncMiniCartFromSession();
});


// Dela varukorg — skapa/maila delad varukorg + lägg alla i cart på delad-varukorg-sidan.
// Modalen öppnas/stängs via temats befintliga modal-system (src/js/utils/modal.js).
function $2d30c23ff7d02ce1$var$getAjaxUrl() {
    return window.liGlobal && window.liGlobal.ajaxUrl || '/wp-admin/admin-ajax.php';
}
function $2d30c23ff7d02ce1$var$getModal() {
    return document.querySelector('[data-modal_id="share-cart"]');
}
function $2d30c23ff7d02ce1$var$setMsg(el, text, type) {
    if (!el) return;
    el.textContent = text || '';
    el.className = 'text-sm m-0';
    if (type === 'success') el.classList.add('text-green-700');
    if (type === 'error') el.classList.add('text-red-700');
}
async function $2d30c23ff7d02ce1$var$postAjax(action, data = {}) {
    const body = new URLSearchParams();
    body.set('action', action);
    Object.keys(data).forEach((k)=>body.set(k, data[k] == null ? '' : data[k]));
    const res = await fetch($2d30c23ff7d02ce1$var$getAjaxUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: body.toString()
    });
    return res.json();
}
async function $2d30c23ff7d02ce1$var$copyToClipboard(text) {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (err) {
    // fallback nedan
    }
    const input = document.createElement('textarea');
    input.value = text;
    input.style.position = 'fixed';
    input.style.left = '-1000px';
    document.body.appendChild(input);
    input.select();
    try {
        document.execCommand('copy');
        return true;
    } catch (err) {
        return false;
    } finally{
        document.body.removeChild(input);
    }
}
// Lyssna på när modal-knappen klickas. Modal.js sätter .active först, sedan kör vi init.
document.addEventListener('click', function(e) {
    const toggle = e.target.closest('[data-toggle_modal="share-cart"]');
    if (!toggle) return;
    // Om modal är på väg att öppnas (inte redan active), initiera innehåll.
    // Timeout för att låta modal.js hinna sätta .active.
    setTimeout(async ()=>{
        const modal = $2d30c23ff7d02ce1$var$getModal();
        if (!modal || !modal.classList.contains('active')) return;
        const linkInput = modal.querySelector('#lw-share-cart-link');
        const copyBtn = modal.querySelector('#lw-share-cart-copy');
        const msgEl = modal.querySelector('#lw-share-cart-msg');
        // Regenerera varje gång modal öppnas (varukorgens innehåll kan ha ändrats).
        if (linkInput) linkInput.value = '';
        if (copyBtn) copyBtn.disabled = true;
        $2d30c23ff7d02ce1$var$setMsg(msgEl, '', '');
        try {
            const resp = await $2d30c23ff7d02ce1$var$postAjax('lw_create_shared_cart');
            if (resp && resp.success && resp.data && resp.data.url) {
                modal.dataset.token = resp.data.token;
                if (linkInput) linkInput.value = resp.data.url;
                if (copyBtn) copyBtn.disabled = false;
            } else $2d30c23ff7d02ce1$var$setMsg(msgEl, resp && resp.data && resp.data.msg || 'Kunde inte skapa delad varukorg.', 'error');
        } catch (err) {
            $2d30c23ff7d02ce1$var$setMsg(msgEl, 'Kunde inte skapa delad varukorg.', 'error');
        }
    }, 0);
}, true);
// Kopiera länk
document.addEventListener('click', async function(e) {
    const copyBtn = e.target.closest('#lw-share-cart-copy');
    if (!copyBtn) return;
    e.preventDefault();
    const modal = $2d30c23ff7d02ce1$var$getModal();
    const linkInput = modal && modal.querySelector('#lw-share-cart-link');
    if (!linkInput || !linkInput.value) return;
    const ok = await $2d30c23ff7d02ce1$var$copyToClipboard(linkInput.value);
    const label = copyBtn.dataset.defaultLabel || copyBtn.textContent.trim();
    copyBtn.dataset.defaultLabel = label;
    copyBtn.textContent = ok ? 'Kopierat!' : 'Kunde inte kopiera';
    setTimeout(()=>{
        copyBtn.textContent = label;
    }, 1800);
});
// Skicka e-post
document.addEventListener('submit', async function(e) {
    const form = e.target.closest('#lw-share-cart-form');
    if (!form) return;
    e.preventDefault();
    const modal = $2d30c23ff7d02ce1$var$getModal();
    const msgEl = modal && modal.querySelector('#lw-share-cart-msg');
    const token = modal && modal.dataset.token;
    const labelEl = form.querySelector('.lw-share-cart-submit-label');
    const loadingEl = form.querySelector('.lw-share-cart-submit-loading');
    const submitBtn = form.querySelector('button[type="submit"]');
    if (!token) {
        $2d30c23ff7d02ce1$var$setMsg(msgEl, 'Ingen delad varukorg att skicka.', 'error');
        return;
    }
    const to = form.querySelector('#lw-share-cart-to').value.trim();
    const fromName = form.querySelector('#lw-share-cart-from-name').value.trim();
    const message = form.querySelector('#lw-share-cart-message').value.trim();
    if (!to) {
        $2d30c23ff7d02ce1$var$setMsg(msgEl, 'Ange en e-postadress.', 'error');
        return;
    }
    submitBtn.disabled = true;
    if (labelEl) labelEl.classList.add('hidden');
    if (loadingEl) loadingEl.classList.remove('hidden');
    $2d30c23ff7d02ce1$var$setMsg(msgEl, '', '');
    try {
        const resp = await $2d30c23ff7d02ce1$var$postAjax('lw_email_shared_cart', {
            token: token,
            to: to,
            from_name: fromName,
            message: message
        });
        if (resp && resp.success) {
            $2d30c23ff7d02ce1$var$setMsg(msgEl, resp.data && resp.data.msg || 'Mejlet har skickats.', 'success');
            form.reset();
        } else $2d30c23ff7d02ce1$var$setMsg(msgEl, resp && resp.data && resp.data.msg || 'Kunde inte skicka mejlet.', 'error');
    } catch (err) {
        $2d30c23ff7d02ce1$var$setMsg(msgEl, 'Kunde inte skicka mejlet.', 'error');
    } finally{
        submitBtn.disabled = false;
        if (labelEl) labelEl.classList.remove('hidden');
        if (loadingEl) loadingEl.classList.add('hidden');
    }
});
function $2d30c23ff7d02ce1$var$lwWcAjaxUrl(endpoint) {
    const tpl = window.wc_add_to_cart_params && window.wc_add_to_cart_params.wc_ajax_url || '/?wc-ajax=%%endpoint%%';
    return tpl.replace('%%endpoint%%', endpoint);
}
// Hämta fragmenter från WC och uppdatera mini-carten (samma flöde som mini-cart.js refreshMiniCart).
function $2d30c23ff7d02ce1$var$refreshMiniCartFragments() {
    if (!window.jQuery) return Promise.resolve();
    const $ = window.jQuery;
    return new Promise((resolve)=>{
        $.ajax({
            url: $2d30c23ff7d02ce1$var$lwWcAjaxUrl('get_refreshed_fragments'),
            type: 'POST',
            beforeSend: function() {
                $(document.body).trigger('wc_fragment_refresh');
            },
            success: function(data) {
                if (!data || !data.fragments) {
                    resolve();
                    return;
                }
                $.each(data.fragments, function(selector, html) {
                    if (selector === 'total_count') return;
                    $(selector).replaceWith(html);
                });
                const hasItems = data.fragments.total_count > 0;
                if (hasItems) {
                    $('.checkout-button').removeClass('disabled');
                    $('.lw-share-cart-btn').removeClass('hidden');
                } else {
                    $('.checkout-button').addClass('disabled');
                    $('.lw-share-cart-btn').addClass('hidden');
                }
                $(document.body).trigger('wc_fragments_refreshed', [
                    data.fragments
                ]);
                $(document.body).trigger('wc_fragments_loaded', [
                    data.fragments
                ]);
                $(document.body).trigger('cart_totals_refreshed');
                resolve();
            },
            error: function() {
                if (window.jQuery) $(document.body).trigger('wc_fragments_ajax_error');
                resolve();
            }
        });
    });
}
// "Lägg alla i min varukorg"-knappen på delad-varukorg-sidan.
document.addEventListener('click', async function(e) {
    const btn = e.target.closest('#lw-add-shared-cart-btn');
    if (!btn) return;
    e.preventDefault();
    const token = btn.dataset.token;
    const msgEl = document.getElementById('lw-shared-cart-msg');
    const labelEl = btn.querySelector('.lw-add-shared-cart-label');
    const loadingEl = btn.querySelector('.lw-add-shared-cart-loading');
    if (!token) return;
    btn.disabled = true;
    if (labelEl) labelEl.classList.add('hidden');
    if (loadingEl) loadingEl.classList.remove('hidden');
    $2d30c23ff7d02ce1$var$setMsg(msgEl, '', '');
    try {
        const resp = await $2d30c23ff7d02ce1$var$postAjax('lw_add_shared_cart_to_cart', {
            token: token
        });
        if (!resp || !resp.success) {
            $2d30c23ff7d02ce1$var$setMsg(msgEl, resp && resp.data && resp.data.msg || "Kunde inte l\xe4gga till i varukorgen.", 'error');
            return;
        }
        await $2d30c23ff7d02ce1$var$refreshMiniCartFragments();
        $2d30c23ff7d02ce1$var$setMsg(msgEl, resp.data.msg || 'Tillagt i varukorgen.', 'success');
        // Öppna mini-carten efter kort delay.
        setTimeout(()=>{
            const dropdown = document.getElementById('mini-cart-dropdown');
            if (dropdown && dropdown.parentElement) {
                dropdown.parentElement.classList.add('active');
                document.body.classList.add('mini-cart-open');
            }
        }, 300);
    } catch (err) {
        $2d30c23ff7d02ce1$var$setMsg(msgEl, "Kunde inte l\xe4gga till i varukorgen.", 'error');
    } finally{
        btn.disabled = false;
        if (labelEl) labelEl.classList.remove('hidden');
        if (loadingEl) loadingEl.classList.add('hidden');
    }
});


document.addEventListener('DOMContentLoaded', function() {
    const singleProduct = document.querySelector('.single-product-content');
    if (!singleProduct) return;
    const buttons = singleProduct.querySelectorAll('.variation-button');
    if (buttons.length === 0) return;
    for (const button of buttons){
        const variationValue = parseFloat(button.dataset.variationValue);
        if (variationValue >= liGlobal.defaultProductQty) {
            button.classList.add('selected');
            button.dispatchEvent(new Event('click', {
                bubbles: true
            }));
            break;
        }
    }
});
function $0679cf766a7523a0$var$handleVariationSelection(button) {
    const singleProduct = button.closest('.single-product-content');
    if (!singleProduct) return;
    const buttons = singleProduct.querySelectorAll('.variation-button');
    if (buttons.length === 0) return;
    const variationSelect = singleProduct.querySelector('select#pa_antal');
    const buttonValue = button.dataset.variationValue;
    const selectedVariation = singleProduct.querySelector('.selected-variation');
    buttons.forEach((button)=>{
        button.classList.remove('selected');
    });
    button.classList.add('selected');
    variationSelect.value = buttonValue;
    variationSelect.dispatchEvent(new Event('change', {
        bubbles: true
    }));
    if (selectedVariation) {
        selectedVariation.querySelector('.selected-variation-price').textContent = button.querySelector('.price').textContent;
        selectedVariation.querySelector('.selected-variation-name').textContent = button.dataset.variationValue;
    }
    if (typeof window.updateHedgeCalculator === 'function' && button.dataset.variationId) window.updateHedgeCalculator(button.dataset.variationId);
}
document.addEventListener('click', function(e) {
    if (e.target.closest('.variation-button')) $0679cf766a7523a0$var$handleVariationSelection(e.target.closest('.variation-button'));
});
// Plus/minus-stepper för kvantitetsfältet på single-product (utan häckkalkylator).
// Knapparna renderas i WC:s quantity-input-mall, på vardera sida om inputen.
document.addEventListener('click', function(e) {
    const btn = e.target.closest('.lw-qty-minus, .lw-qty-plus');
    if (!btn) return;
    const input = btn.closest('.quantity')?.querySelector('input.qty, input[name="quantity"]');
    if (!input || input.readOnly) return;
    e.preventDefault();
    const step = parseFloat(input.step) || 1;
    const min = input.min !== '' ? parseFloat(input.min) : 1;
    const max = input.max !== '' && parseFloat(input.max) > 0 ? parseFloat(input.max) : Infinity;
    let val = parseFloat(input.value);
    if (isNaN(val)) val = min;
    val += btn.classList.contains('lw-qty-plus') ? step : -step;
    val = Math.min(max, Math.max(min, val));
    input.value = val;
    input.dispatchEvent(new Event('change', {
        bubbles: true
    }));
});
document.addEventListener('click', function(e) {
    if (e.target.closest('.go-to-reviews')) {
        e.preventDefault();
        const reviews = document.querySelector('#reviews');
        const reviewDetails = reviews.closest('details');
        if (reviewDetails) {
            const rect = reviewDetails.getBoundingClientRect();
            window.scrollTo({
                top: window.scrollY + rect.top - 80,
                behavior: 'smooth'
            });
            reviewDetails.open = true;
        }
    }
});


// Häckkalkylator (simple + variable) — tier-medveten (volymrabatt).
document.addEventListener('DOMContentLoaded', function() {
    const calc = document.querySelector('.hedge-calculator');
    if (!calc) return;
    const metersInput = calc.querySelector('#hedge-meters');
    const qtyInput2 = calc.querySelector('#hedge-qty');
    const pricePerMeterDisplay = calc.querySelector('[data-hedge-price-per-meter]');
    const pricePerMeterSummary = document.querySelector('[data-hedge-price-per-meter-summary]');
    const totalPriceDisplay = calc.querySelector('[data-hedge-total-price]');
    const priceArea = calc.querySelector('[data-hedge-price-area]');
    const minQtyValue = document.querySelector('[data-hedge-min-qty-value]');
    const belowMinWarning = calc.querySelector('[data-hedge-below-min-warning]');
    const form = calc.closest('.entry-summary')?.querySelector('form.cart');
    const qtyInput = form?.querySelector('input[name="quantity"]');
    const single_add_to_cart_button = form?.querySelector('.single_add_to_cart_button');
    const variationsRaw = calc.dataset.variations;
    const variations = variationsRaw ? JSON.parse(variationsRaw) : null;
    // parseFloat, inte parseInt: plantor per meter får vara decimaltal (t.ex. 2.5).
    // Attributet skrivs alltid med punkt av lw_plants_per_meter_attr().
    let plantsPerMeter = parseFloat(calc.dataset.plantsPerMeter);
    let minQuantity = parseInt(calc.dataset.minQuantity, 10);
    let activePrice = parseFloat(calc.dataset.activePrice);
    let regularPrice = parseFloat(calc.dataset.regularPrice) || activePrice;
    let salePrice = calc.dataset.salePrice ? parseFloat(calc.dataset.salePrice) : null;
    let currentTiers = readInitialTiers();
    // Produktens enhet ("st" som standard, t.ex. "m3"). Produkt-global — byts
    // aldrig vid variantbyte. Renderas server-side i lw_single_product_hedge_calculator.php.
    const unit = calc.dataset.unit || 'st';
    if (qtyInput) {
        qtyInput.readOnly = true;
        qtyInput.tabIndex = -1;
        qtyInput.closest('.quantity')?.classList.add('hidden');
    }
    if (single_add_to_cart_button) single_add_to_cart_button.classList.add('md:col-span-full!', 'col-span-2!');
    function escapeHtml(s) {
        const div = document.createElement('div');
        div.textContent = String(s);
        return div.innerHTML;
    }
    function formatNumber(n) {
        return Math.round(n).toLocaleString('sv-SE');
    }
    function formatDecimal(n) {
        return String(Math.round(n * 100) / 100);
    }
    function readInitialTiers() {
        // För variabla produkter: använd default-variantens tiers (sätts senare av updateHedgeCalculator).
        // För simpla: läs från data-pricing-tiers på containern.
        if (variations && calc.dataset.hedgeInitialVariationId) {
            const id = parseInt(calc.dataset.hedgeInitialVariationId, 10);
            if (variations[id] && Array.isArray(variations[id].pricingTiers)) return variations[id].pricingTiers;
            return [];
        }
        try {
            const parsed = calc.dataset.pricingTiers ? JSON.parse(calc.dataset.pricingTiers) : [];
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    }
    /**
     * Returnerar effektivt pris-per-styck för en given kvantitet.
     * Om en pristrappa matchar returneras tier-priset, annars activePrice (= reapris om satt, annars baspris).
     */ function effectivePrice(qty) {
        if (!Array.isArray(currentTiers) || currentTiers.length === 0) return activePrice;
        for(let i = 0; i < currentTiers.length; i++){
            const t = currentTiers[i];
            const min = parseInt(t.min, 10);
            const max = t.max && t.max > 0 ? parseInt(t.max, 10) : Infinity;
            if (qty >= min && qty <= max) return parseFloat(t.price);
        }
        return activePrice;
    }
    let hedgeCurrentVariationId = null;
    if (variations && calc.dataset.hedgeInitialVariationId) hedgeCurrentVariationId = parseInt(calc.dataset.hedgeInitialVariationId, 10);
    function sanitizeHedgeHeightDisplay(s) {
        if (s == null || s === '') return '';
        return String(s).replace(/[\u2013\u2014\u2212]/g, '-').replace(/[^\d-]/g, '').replace(/-+/g, '-').replace(/^-+|-+$/g, '');
    }
    function updateHedgeStickySummary() {
        const heightEl = document.querySelector('[data-hedge-height-show]');
        const metersEl = document.querySelector('[data-hedge-meters-show]');
        const qtyEl = document.querySelector('[data-hedge-qty-show]');
        const stickyTotalEl = document.querySelector('[data-hedge-sticky-total-price]');
        const stickyMinEl = document.querySelector('[data-hedge-sticky-min-qty]');
        if (metersEl) metersEl.textContent = metersInput.value;
        if (qtyEl) qtyEl.textContent = qtyInput2.value;
        if (stickyTotalEl) {
            const qty = parseInt(qtyInput2.value, 10) || 0;
            const eff = effectivePrice(qty);
            const tierApplies = eff !== activePrice;
            stickyTotalEl.textContent = formatNumber(eff * qty) + ' kr';
        }
        if (stickyMinEl) {
            const label = stickyMinEl.dataset.hedgeStickyMinQtyLabel;
            stickyMinEl.textContent = label ? label + ' ' + minQuantity + ' ' + unit : String(minQuantity) + ' ' + unit;
        }
        if (!heightEl) return;
        if (variations && hedgeCurrentVariationId && variations[hedgeCurrentVariationId]) {
            const h = variations[hedgeCurrentVariationId].heightShow;
            heightEl.textContent = sanitizeHedgeHeightDisplay(h);
            return;
        }
        heightEl.textContent = sanitizeHedgeHeightDisplay(calc.dataset.hedgeHeightInitial);
    }
    /**
     * Uppdaterar pris-per-styck-displayen ("à X kr/st") baserat på aktuell kvantitet.
     * Visar tier-pris bold + ordinarie pris linje-igenom när tier matchar.
     */ function updatePriceDisplay(qty) {
        if (!priceArea) return;
        const eff = effectivePrice(qty);
        const tierApplies = eff !== activePrice;
        // priceArea skrivs via innerHTML — enheten är fritext från admin och escapas.
        const perPiece = ' kr /' + escapeHtml(unit);
        const a = "\xe0 ";
        if (tierApplies) {
            priceArea.innerHTML = '<span class="font-bold text-sale-price" data-hedge-price-display>' + a + formatNumber(eff) + perPiece + '</span>' + '<span class="text-sm font-normal text-secondary-400 line-through" data-hedge-regular-price-display>' + formatNumber(regularPrice) + perPiece + '</span>';
            return;
        }
        if (salePrice !== null && salePrice < regularPrice) {
            priceArea.innerHTML = '<span class="font-bold text-sale-price" data-hedge-price-display>' + a + formatNumber(salePrice) + perPiece + '</span>' + '<span class="text-sm font-normal text-secondary-400 line-through" data-hedge-regular-price-display>' + formatNumber(regularPrice) + perPiece + '</span>';
            return;
        }
        priceArea.innerHTML = '<span class="font-bold text-secondary-900" data-hedge-price-display>' + a + formatNumber(activePrice) + perPiece + '</span>';
    }
    function updateBelowMinWarning(qty) {
        if (!belowMinWarning) return;
        const below = qty > 0 && qty < minQuantity;
        const minQtyValueEl = belowMinWarning.querySelector('.min-qty-value');
        belowMinWarning.classList.toggle('hidden', !below);
        if (below && minQtyValueEl) minQtyValueEl.textContent = minQuantity;
    }
    function syncDisplay(qty) {
        if (qtyInput) {
            qtyInput.value = qty;
            qtyInput.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
        const eff = effectivePrice(qty);
        const tierApplies = eff !== activePrice;
        const ppm = eff * plantsPerMeter;
        pricePerMeterDisplay.textContent = '(' + formatNumber(ppm) + ' kr/meter)';
        if (pricePerMeterSummary) pricePerMeterSummary.textContent = '(' + formatNumber(ppm) + ' kr/meter)';
        if (totalPriceDisplay) totalPriceDisplay.textContent = formatNumber(eff * qty) + ' kr';
        updatePriceDisplay(qty);
        updateHedgeStickySummary();
        updateBelowMinWarning(qty);
    }
    // Meter → qty: live uppdatering utan min-clamp
    function onMetersInput() {
        const meters = parseFloat(metersInput.value);
        if (isNaN(meters) || meters <= 0) return;
        const qty = Math.round(meters * plantsPerMeter);
        if (qtyInput2) qtyInput2.value = qty;
        syncDisplay(qty);
    }
    // Meter → qty: clampa endast bort ogiltiga värden (NaN / ≤ 0), inte mot rekommenderat minimum.
    function onMetersCommit() {
        let meters = parseFloat(metersInput.value);
        if (isNaN(meters) || meters <= 0) {
            meters = 1 / plantsPerMeter;
            metersInput.value = formatDecimal(meters);
        }
        const qty = Math.max(1, Math.round(meters * plantsPerMeter));
        if (qtyInput2) qtyInput2.value = qty;
        syncDisplay(qty);
    }
    // Qty → meter: live uppdatering utan min-clamp
    function onQtyInput() {
        const qty = parseInt(qtyInput2.value, 10);
        if (isNaN(qty) || qty <= 0) return;
        metersInput.value = formatDecimal(qty / plantsPerMeter);
        syncDisplay(qty);
    }
    // Qty → meter: clampa endast bort ogiltiga värden (NaN / < 1), inte mot rekommenderat minimum.
    function onQtyCommit() {
        let qty = parseInt(qtyInput2.value, 10);
        if (isNaN(qty) || qty < 1) {
            qty = 1;
            qtyInput2.value = qty;
        }
        metersInput.value = formatDecimal(qty / plantsPerMeter);
        syncDisplay(qty);
    }
    window.updateHedgeCalculator = function(variationId) {
        if (!variations) return;
        const v = variations[variationId];
        if (!v) return;
        // Variantbyte kan trigga updateHedgeCalculator två gånger (egen knapp + WC:s
        // found_variation). Om vi redan kört för denna variant, hoppa över — annars
        // hinner andra körningen läsa just satta värden och resetta felaktigt.
        const nextId = parseInt(variationId, 10);
        if (hedgeCurrentVariationId === nextId) return;
        // Läs av nuvarande meter INNAN vi byter variant — vid variantbyte är det
        // användarens "jag vill plantera X meter häck" som ska behållas; antalet
        // plantor räknas om från nya variantens plants-per-meter.
        const previousMeters = metersInput ? parseFloat(metersInput.value) : NaN;
        plantsPerMeter = v.plantsPerMeter;
        minQuantity = v.minQuantity;
        activePrice = v.price;
        regularPrice = v.regularPrice;
        salePrice = v.salePrice;
        currentTiers = Array.isArray(v.pricingTiers) ? v.pricingTiers : [];
        metersInput.min = '0';
        metersInput.step = 'any';
        if (qtyInput2) qtyInput2.min = '1';
        if (minQtyValue) minQtyValue.textContent = minQuantity;
        hedgeCurrentVariationId = nextId;
        // Behåll meter; räkna om qty. Om meter saknas/ogiltigt — fall tillbaka
        // till nya variantens min. Under-min-varningen triggas via syncDisplay
        // om resulterande qty hamnar under nya minimumet.
        if (isNaN(previousMeters) || previousMeters <= 0) {
            const qty = minQuantity;
            if (qtyInput2) qtyInput2.value = qty;
            metersInput.value = formatDecimal(qty / plantsPerMeter);
            syncDisplay(qty);
        } else {
            const qty = Math.max(1, Math.round(previousMeters * plantsPerMeter));
            metersInput.value = formatDecimal(previousMeters);
            if (qtyInput2) qtyInput2.value = qty;
            syncDisplay(qty);
        }
    };
    metersInput.addEventListener('input', onMetersInput);
    metersInput.addEventListener('change', onMetersCommit);
    if (qtyInput2) {
        qtyInput2.addEventListener('input', onQtyInput);
        qtyInput2.addEventListener('change', onQtyCommit);
    }
    calc.querySelector('.hedge-meters-minus')?.addEventListener('click', function(e) {
        e.preventDefault();
        let m = parseFloat(metersInput.value);
        if (isNaN(m)) m = 1;
        m = Math.max(1, Math.floor(m) - 1);
        metersInput.value = m;
        const qty = Math.max(1, Math.round(m * plantsPerMeter));
        if (qtyInput2) qtyInput2.value = qty;
        syncDisplay(qty);
    });
    calc.querySelector('.hedge-meters-plus')?.addEventListener('click', function(e) {
        e.preventDefault();
        let m = parseFloat(metersInput.value);
        if (isNaN(m)) m = 0;
        m = Math.floor(m) + 1;
        metersInput.value = m;
        const qty = Math.max(1, Math.round(m * plantsPerMeter));
        if (qtyInput2) qtyInput2.value = qty;
        syncDisplay(qty);
    });
    calc.querySelector('.hedge-qty-minus')?.addEventListener('click', function(e) {
        e.preventDefault();
        let q = parseInt(qtyInput2.value, 10);
        if (isNaN(q)) q = 1;
        q = Math.max(1, q - 1);
        qtyInput2.value = q;
        metersInput.value = formatDecimal(q / plantsPerMeter);
        syncDisplay(q);
    });
    calc.querySelector('.hedge-qty-plus')?.addEventListener('click', function(e) {
        e.preventDefault();
        let q = parseInt(qtyInput2.value, 10);
        if (isNaN(q)) q = 0;
        q = q + 1;
        qtyInput2.value = q;
        metersInput.value = formatDecimal(q / plantsPerMeter);
        syncDisplay(q);
    });
    // Lyssna på WooCommerce:s jQuery-event för native variationsväxling (select-dropdowns)
    if (variations && typeof jQuery !== 'undefined') jQuery('form.variations_form').on('found_variation', function(e, variation) {
        if (variation && variation.variation_id) window.updateHedgeCalculator(variation.variation_id);
    });
    // Initial körning — säkerställer att starvärdena reflekterar tier-pris om en
    // tier matchar default-kvantiteten redan vid sidladdning.
    syncDisplay(parseInt(qtyInput2 ? qtyInput2.value : minQuantity, 10) || minQuantity);
});
// Leveranstillfälle – uppdatera text vid variantbyte
if (typeof jQuery !== 'undefined') {
    jQuery('form.variations_form').on('found_variation', function(e, variation) {
        const el = document.getElementById('lw-delivery-occasion');
        const wrapper = document.getElementById('lw-delivery-occasion-wrapper');
        if (!el) return;
        const text = variation.delivery_occasion || '';
        el.textContent = text;
        el.classList.toggle('hidden', !text);
        if (wrapper) wrapper.classList.toggle('hidden', !text);
    });
    jQuery('form.variations_form').on('reset_data', function() {
        const el = document.getElementById('lw-delivery-occasion');
        const wrapper = document.getElementById('lw-delivery-occasion-wrapper');
        if (!el) return;
        el.textContent = '';
        el.classList.add('hidden');
        if (wrapper) wrapper.classList.add('hidden');
    });
}


/**
 * Pristrappor (volymrabatt) — uppdaterar tier-tabellen på single-product-sidan
 * vid variantbyte. För variabla produkter renderas tabellen via det HTML-blob
 * som temat injicerar i varje variations data (woocommerce_available_variation).
 *
 * För enkla produkter renderas tabellen direkt server-side — inget JS behövs här.
 * Häckkalkylatorn (hedge-calculator.js) hanterar sina egna pris-displays.
 */ (function($) {
    'use strict';
    if (typeof $ === 'undefined') return;
    function setTableHtml(html) {
        $('[data-lw-pricing-tiers-target]').html(html || '');
    }
    // Variabla produkter har form.variations_form; enkla har bara form.cart.
    const hasVariationsForm = !!document.querySelector('form.variations_form');
    // currentTiers fylls från found_variation (variabla) eller data-lw-tiers (enkla).
    let currentTiers = [];
    let basePriceHtml = '';
    function findActiveTier(qty) {
        for (const t of currentTiers){
            const max = t.max > 0 ? t.max : Infinity;
            if (qty >= t.min && qty <= max) return t;
        }
        return null;
    }
    // Variantpriset är upplyft till en egen container ovanför variantväljaren
    // (lw_single_product_variation_price.php); WC:s original döljs med CSS.
    // Fallback till WC:s nod för produkter som saknar den upplyfta containern
    // (t.ex. häckkalkylator-produkter).
    function variationPriceSelector() {
        return document.querySelector('[data-lw-variation-price]') ? '[data-lw-variation-price] .price' : '.woocommerce-variation-price .price';
    }
    function getQty() {
        const input = document.querySelector('form.cart input[name="quantity"]');
        const val = input ? parseInt(input.value, 10) : 1;
        return Number.isFinite(val) && val > 0 ? val : 1;
    }
    function updatePriceFor(selector, qty) {
        const $price = $(selector).first();
        if (!$price.length) return;
        const tier = findActiveTier(qty);
        if (tier && tier.price_html) $price.html(tier.price_html);
        else if (basePriceHtml) $price.html(basePriceHtml);
    }
    // --- Variabla produkter ---
    $(document).on('found_variation', 'form.variations_form', function(e, variation) {
        if (!variation) return;
        currentTiers = Array.isArray(variation.pricing_tiers) ? variation.pricing_tiers : [];
        basePriceHtml = variation.price_html || '';
        setTableHtml(variation.pricing_tiers_table_html || '');
        // Defer så WC:s egen handler hinner sätta sitt pris först — vi kör efter.
        if (currentTiers.length) setTimeout(()=>updatePriceFor(variationPriceSelector(), getQty()), 0);
    });
    $(document).on('reset_data hide_variation', 'form.variations_form', function() {
        currentTiers = [];
        basePriceHtml = '';
        setTableHtml('');
    });
    // --- Enkla produkter: init från data-lw-tiers ---
    if (!hasVariationsForm) {
        const $simpleContainer = $('.lw-pricing-tiers-price').first();
        const raw = $simpleContainer.attr('data-lw-tiers');
        if (raw) try {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed) && parsed.length) {
                currentTiers = parsed;
                basePriceHtml = $simpleContainer.find('.price').first().html() || '';
                // Initial render om sidan laddas med qty inom en tier.
                updatePriceFor('.lw-pricing-tiers-price .price', getQty());
            }
        } catch (err) {
        // ignore parse errors
        }
    }
    // --- Kvantitetsändring: dirigera till rätt prismål ---
    $(document).on('input change', 'form.cart input[name="quantity"]', function() {
        if (!currentTiers.length) return;
        const qty = parseInt(this.value, 10) || 1;
        if (hasVariationsForm) updatePriceFor(variationPriceSelector(), qty);
        else updatePriceFor('.lw-pricing-tiers-price .price', qty);
    });
})(window.jQuery);


// Fyller den upplyfta variantpris-containern (se
// includes/woocommerce/action-functions/single-product/lw_single_product_variation_price.php)
// med WC:s egen price_html vid variantbyte. WC:s original ligger kvar i
// formuläret men döljs med CSS, så WC:s egen JS kan fortsätta skriva om den
// utan att vi behöver flytta noder fram och tillbaka.
//
// Pristrappor: pricing-tiers.js skriver över .price inuti containern med
// trapp-priset i en setTimeout(0) — den binder sin found_variation-handler före
// den här filen och kör dessutom deferrat, så trapp-priset vinner.
(function() {
    if (!window.jQuery) return;
    window.jQuery(function($) {
        const target = document.querySelector('[data-lw-variation-price]');
        if (!target) return;
        const form = $('form.variations_form');
        if (!form.length) return;
        form.on('found_variation', function(event, variation) {
            const price = variation && variation.price_html || '';
            // Styckpriset ligger som syskon EFTER .price, inte inuti den —
            // pricing-tiers.js skriver om .price vid kvantitetsändring.
            const unit = price && variation && variation.lw_unit_price_html || '';
            target.innerHTML = price + unit;
        });
        form.on('reset_data hide_variation', function() {
            target.innerHTML = '';
        });
    });
})();


// Låter styckpris-parentesen "(104,98 kr/st)" följa pristrappan.
//
// Servern skickar färdig HTML per trappsteg i data-lw-unit-tiers och ordinarie
// styckpris i data-lw-unit-base (se helpers/lw_unit_price.php). Ingen
// prisformatering sker här — bara ett byte av innehåll efter kvantitet.
//
// Medvetet TILLSTÅNDSLÖST: allt läses från spanen vid varje anrop. På variabla
// produkter skapas spanen av variation-price.js vid found_variation, alltså
// efter att den här modulen initierats — en cachad "utgångspunkt" hade då blivit
// null och parentesen frusit på ordinarie pris.
//
// found_variation lyssnas delegerat på document. Det garanterar att vi kör
// EFTER variation-price.js, som binder direkt på formuläret (direkta handlers
// körs före delegerade när eventet bubblar).
(function() {
    function qty() {
        const input = document.querySelector('form.cart input[name="quantity"]');
        const value = input ? parseInt(input.value, 10) : 1;
        return Number.isFinite(value) && value > 0 ? value : 1;
    }
    function apply() {
        const span = document.querySelector('[data-lw-unit-price]');
        if (!span) return;
        let tiers = [];
        try {
            const parsed = JSON.parse(span.dataset.lwUnitTiers || '[]');
            if (Array.isArray(parsed)) tiers = parsed;
        } catch (e) {
        // ignorera parse-fel — då står ordinarie styckpris kvar
        }
        const current = qty();
        const tier = tiers.find(function(t) {
            const max = t.max > 0 ? t.max : Infinity;
            return current >= t.min && current <= max;
        });
        const next = tier ? tier.inner : span.dataset.lwUnitBase || '';
        if (span.innerHTML !== next) span.innerHTML = next;
    }
    function isQtyField(target) {
        return target && target.matches && target.matches('form.cart input[name="quantity"]');
    }
    function init() {
        apply();
        document.addEventListener('input', function(e) {
            if (isQtyField(e.target)) apply();
        });
        document.addEventListener('change', function(e) {
            if (isQtyField(e.target)) apply();
        });
        if (!window.jQuery) return;
        window.jQuery(document).on('found_variation', 'form.variations_form', apply);
    }
    // Bundlen kan laddas både före och efter DOMContentLoaded — kör direkt om
    // dokumentet redan är parsat, annars vid eventet.
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();


// Totalsumma (antal × styckpris) på produkter utan häckkalkylator.
//
// Startsumman renderas server-side i lw_single_product_total_price.php; här
// räknas den om live när kunden ändrar antal — tier-medvetet, samma logik som
// effectivePrice() i hedge-calculator.js.
//
// Variabla produkter byter dessutom underlag vid variantbyte: varje variant
// bär sitt eget lw_total_unit_price + lw_total_tiers i variations-JSON:en.
// Ingen vald variant (WC visar prisintervall) → raden döljs.
document.addEventListener('DOMContentLoaded', function() {
    const total = document.querySelector('[data-lw-product-total]');
    if (!total) return;
    const qtyInput = total.closest('form.cart')?.querySelector('input[name="quantity"]');
    if (!qtyInput) return;
    const valueEl = total.querySelector('[data-lw-product-total-value]');
    if (!valueEl) return;
    function parseTiers(raw) {
        try {
            const parsed = JSON.parse(raw || '[]');
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            // ignorera parse-fel — utan tiers används styckpriset rakt av
            return [];
        }
    }
    let unitPrice = parseFloat(total.dataset.unitPrice) || 0;
    let tiers = parseTiers(total.dataset.tiers);
    // Butikens prisformat, speglat från wc_price()-inställningarna i PHP så att
    // den omräknade summan ser exakt likadan ut som den server-renderade.
    const decimals = parseInt(total.dataset.decimals, 10);
    const format = {
        decimals: Number.isFinite(decimals) ? decimals : 2,
        decimalSep: total.dataset.decimalSep ?? ',',
        thousandSep: total.dataset.thousandSep ?? ' ',
        trimZeros: total.dataset.trimZeros === '1'
    };
    function formatAmount(amount) {
        const fixed = Math.abs(amount).toFixed(format.decimals);
        const [whole, fraction] = fixed.split('.');
        let out = whole.replace(/\B(?=(\d{3})+(?!\d))/g, format.thousandSep);
        if (format.decimals > 0 && !(format.trimZeros && /^0+$/.test(fraction))) out += format.decimalSep + fraction;
        return (amount < 0 ? '-' : '') + out;
    }
    function effectivePrice(qty) {
        for (const tier of tiers){
            const max = tier.max && tier.max > 0 ? parseInt(tier.max, 10) : Infinity;
            if (qty >= parseInt(tier.min, 10) && qty <= max) return parseFloat(tier.price);
        }
        return unitPrice;
    }
    // Besparingen finns på två ställen i markupen: hela meningen efter priset på
    // desktop, kortformen bredvid minsta kvantitet på mobil. Vilken som syns
    // avgörs av CSS; här fylls och växlas båda. Varje text bär sin egen
    // översatta mall i data-template, så formuleringarna bara finns i PHP.
    const savingsEls = total.querySelectorAll('[data-lw-product-total-savings]');
    const savingsTexts = total.querySelectorAll('[data-lw-savings-text]');
    function update() {
        const qty = parseInt(qtyInput.value, 10);
        if (!Number.isFinite(qty) || qty < 1) return;
        const unit = effectivePrice(qty);
        valueEl.textContent = formatAmount(unit * qty) + ' kr';
        if (!savingsEls.length) return;
        const savings = (unitPrice - unit) * qty;
        if (savings > 0) {
            const amount = formatAmount(savings) + ' kr';
            savingsTexts.forEach(function(el) {
                el.textContent = (el.dataset.template || '').replace('%s', amount);
            });
            savingsEls.forEach(function(el) {
                el.classList.remove('hidden');
            });
        } else savingsEls.forEach(function(el) {
            el.classList.add('hidden');
        });
    }
    qtyInput.addEventListener('input', update);
    qtyInput.addEventListener('change', update);
    // --- Variabla produkter: byt underlag vid variantbyte ---
    if (!window.jQuery) return;
    window.jQuery(function($) {
        const form = $('form.variations_form');
        if (!form.length) return;
        form.on('found_variation', function(event, variation) {
            unitPrice = parseFloat(variation && variation.lw_total_unit_price) || 0;
            tiers = Array.isArray(variation && variation.lw_total_tiers) ? variation.lw_total_tiers : [];
            total.classList.toggle('hidden', unitPrice <= 0);
            if (unitPrice > 0) update();
        });
        form.on('reset_data hide_variation', function() {
            unitPrice = 0;
            tiers = [];
            total.classList.add('hidden');
        });
    });
});



/**
 * Galleribilden på produktkorten hämtas först när muspekaren når kortet.
 *
 * PHP (lw_loop_product_hover_image) skriver ut <img> utan src/srcset — bara
 * data-hover-*. Utan det hämtade webbläsaren alla bilder direkt trots
 * loading="lazy", eftersom korten ligger i eller strax under viewporten.
 *
 * Bunden bara när enheten faktiskt har hover: på touch triggas bilden aldrig,
 * så där laddas ingenting alls.
 */ const $24b68065ce23e70d$var$SELECTOR = '.loop-product-second-image[data-hover-src]';
function $24b68065ce23e70d$var$loadHoverImage(img) {
    const src = img.dataset.hoverSrc;
    if (!src) return;
    // Nolla data-hover-src först. Då matchar bilden inte SELECTOR längre och
    // hämtas bara en gång, även om pekaren far in och ut över kortet.
    delete img.dataset.hoverSrc;
    // Fade in när bytesen är på plats — annars poppar bilden fram mitt i
    // opacity-övergången (se .loop-product-second-image i loop-product.css).
    img.addEventListener('load', ()=>img.classList.add('is-loaded'), {
        once: true
    });
    // sizes före srcset: annars väljer webbläsaren kandidat mot standardbredden 100vw.
    if (img.dataset.hoverSizes) {
        img.sizes = img.dataset.hoverSizes;
        delete img.dataset.hoverSizes;
    }
    if (img.dataset.hoverSrcset) {
        img.srcset = img.dataset.hoverSrcset;
        delete img.dataset.hoverSrcset;
    }
    img.src = src;
}
function $24b68065ce23e70d$var$handlePointerOver(event) {
    const card = event.target?.closest?.('li.product');
    if (!card) return;
    const img = card.querySelector($24b68065ce23e70d$var$SELECTOR);
    if (img) $24b68065ce23e70d$var$loadHoverImage(img);
}
if (window.matchMedia && window.matchMedia('(hover: hover)').matches) // Delegerat på document: produktkort tillkommer via load more och
// Relevanssis live-sök, och slipper då varsin lyssnare.
document.addEventListener('pointerover', $24b68065ce23e70d$var$handlePointerOver, {
    passive: true
});



let $aed6535f5ac7ba1b$var$productIds;
function $aed6535f5ac7ba1b$var$checkCookie() {
    const latest_product_cookies = (0, $aa7c3aec4e5384fe$export$4be65e66cfa2648a)('latest_product_cookies');
    if (latest_product_cookies != null && latest_product_cookies != undefined && latest_product_cookies != '') $aed6535f5ac7ba1b$var$productIds = JSON.parse(latest_product_cookies);
    else $aed6535f5ac7ba1b$var$productIds = [];
}
document.addEventListener('DOMContentLoaded', $aed6535f5ac7ba1b$var$checkCookie);
// Lägger till en produkt-id i listan och skriver tillbaka hela JSON-arrayen.
function $aed6535f5ac7ba1b$var$setCookie(cName, productId, expDays) {
    if (!$aed6535f5ac7ba1b$var$productIds) $aed6535f5ac7ba1b$var$productIds = [];
    $aed6535f5ac7ba1b$var$productIds.push(productId);
    (0, $aa7c3aec4e5384fe$export$110700823644f4a6)(cName, JSON.stringify($aed6535f5ac7ba1b$var$productIds), expDays);
}
const $aed6535f5ac7ba1b$var$products = document.querySelectorAll('.product-item, li.product');
$aed6535f5ac7ba1b$var$products.forEach((product)=>{
    product.addEventListener('click', function() {
        const cookieId = product.querySelector('[data-post-id]').dataset.postId;
        $aed6535f5ac7ba1b$var$setCookie('latest_product_cookies', cookieId, 30);
    });
});




// Delad helper: gör ett element till en modal.js-driven modal under
// lg-breakpointen (< 1024px) och tillbaka till statiskt innehåll på desktop.
// Delas av kategori-sidebaren (category-accordion.js) och arkivfiltren
// (woo-filters.js) som tidigare hade var sin nästan identiska kopia.
/**
 * @param {string} selector  CSS-selektor för wrapper-elementet.
 * @param {string} modalId   data-modal_id som modal.js öppnar mot på mobil.
 */ function $115be675649c4b0c$export$d613139c64264077(selector, modalId) {
    const el = document.querySelector(selector);
    if (!el) return;
    const update = ()=>{
        const closeBtn = el.querySelector('.close-btn');
        if (window.innerWidth >= 1024) {
            if (closeBtn) closeBtn.click();
            el.removeAttribute('data-modal_id');
            el.classList.remove('modal');
        } else {
            el.setAttribute('data-modal_id', modalId);
            el.classList.add('modal');
        }
    };
    update();
    window.addEventListener('resize', update);
}


/**
 * Add dropdown attributes to filters
 * - data-dropdown-trigger: The id of the filter
 * - data-dropdown: The id of the filter dropdown
 */ function $0dd0b49fd9ca6c5a$var$addAttributesToFilters() {
    // Scope to .archive-filters so we don't catch unrelated widgets (e.g. product categories sidebar)
    const filters = document.querySelectorAll('.archive-filters .woo-widget:not(.widget_layered_nav_filters)');
    filters.forEach((filter)=>{
        const id = filter.id;
        const filterButton = filter.querySelector('.widget-button');
        const filterDropdown = filter.querySelector('ul');
        if (!filterButton || !filterDropdown) return;
        filterButton.setAttribute('data-dropdown-trigger', id);
        filterDropdown.setAttribute('data-dropdown', id);
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    $0dd0b49fd9ca6c5a$var$addAttributesToFilters();
});
/**
 * Add modal attributes to filters on mobile.
 * Delar logik med kategori-sidebaren via initResponsiveModal.
 */ function $0dd0b49fd9ca6c5a$var$handleModalAttributesForFilters() {
    (0, $115be675649c4b0c$export$d613139c64264077)('.archive-filters', 'filters');
}
document.addEventListener('DOMContentLoaded', ()=>{
    $0dd0b49fd9ca6c5a$var$handleModalAttributesForFilters();
});
/**
 * Lazy URL updater (prevents spamming pushState)
 */ let $0dd0b49fd9ca6c5a$var$lazyUrlTimer = null;
function $0dd0b49fd9ca6c5a$var$lazyUpdateUrl(url, delay = 300) {
    clearTimeout($0dd0b49fd9ca6c5a$var$lazyUrlTimer);
    $0dd0b49fd9ca6c5a$var$lazyUrlTimer = setTimeout(()=>{
        window.history.pushState({}, '', url);
    }, delay);
}
/**
 * Prefetch cache
 */ const $0dd0b49fd9ca6c5a$var$archivePrefetchCache = new Map();
/**
 * Prefetch URL if not already cached
 */ async function $0dd0b49fd9ca6c5a$var$prefetchArchive(url) {
    if (!url || $0dd0b49fd9ca6c5a$var$archivePrefetchCache.has(url)) return;
    try {
        const response = await fetch(url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        const html = await response.text();
        $0dd0b49fd9ca6c5a$var$archivePrefetchCache.set(url, html);
    } catch (err) {
        console.warn('Prefetch failed:', url);
    }
}
/**
 * SCROLL FLAG (only scroll on pagination)
 */ let $0dd0b49fd9ca6c5a$var$shouldScrollToAnchor = false;
/**
 * Apply DOM updates from parsed HTML
 */ function $0dd0b49fd9ca6c5a$var$updateArchiveDomFromDoc(doc) {
    const productListing = document.querySelector('ul.products');
    const resultCount = document.querySelector('.woocommerce-result-count');
    const pagination = document.querySelector('.woocommerce-pagination');
    const filtersActive = document.querySelector('.widget_layered_nav_filters');
    const archiveFilters = document.querySelector('.archive-filters');
    const ordering = document.querySelector('.woocommerce-ordering');
    const newProducts = doc.querySelector('ul.products');
    const newResultCount = doc.querySelector('.woocommerce-result-count');
    const newPagination = doc.querySelector('.woocommerce-pagination');
    const newFiltersActive = doc.querySelector('.widget_layered_nav_filters');
    const newArchiveFilters = doc.querySelector('.archive-filters');
    const newOrdering = doc.querySelector('.woocommerce-ordering');
    if (newProducts && productListing) {
        productListing.innerHTML = newProducts.innerHTML;
        productListing.classList.remove('animate-pulse');
        // Re-init WooCommerce variations på nya formulär (Woo kräver jQuery...)
        if (window.jQuery) jQuery(function($) {
            const $forms = $('.variations_form');
            if ($forms.length) $forms.each(function() {
                $(this).wc_variation_form();
            });
        });
        (0, $6541fadd07ac8ad5$export$7454541f89b375e)();
    }
    if (newArchiveFilters && archiveFilters) {
        archiveFilters.innerHTML = newArchiveFilters.innerHTML;
        $0dd0b49fd9ca6c5a$var$addAttributesToFilters();
    }
    if (newOrdering && ordering) ordering.innerHTML = newOrdering.innerHTML;
    if (newFiltersActive && filtersActive) filtersActive.innerHTML = newFiltersActive.innerHTML;
    else if (!newFiltersActive && filtersActive) filtersActive.innerHTML = '';
    if (newResultCount && resultCount) resultCount.innerHTML = newResultCount.innerHTML;
    if (newPagination && pagination) pagination.innerHTML = newPagination.innerHTML;
    else if (!newPagination && pagination) pagination.innerHTML = '';
    else if (newPagination && !pagination) {
        const newPaginationEl = document.createElement('nav');
        newPaginationEl.className = 'woocommerce-pagination';
        newPaginationEl.innerHTML = newPagination.innerHTML;
        productListing?.after(newPaginationEl);
    }
    // PREFETCH next pagination page
    const nextPageLink = newPagination?.querySelector('a.next') || newPagination?.querySelector('.page-numbers.next');
    if (nextPageLink) $0dd0b49fd9ca6c5a$var$prefetchArchive(nextPageLink.href);
    // SCROLL TO ANCHOR IF PAGINATION TRIGGERED
    if ($0dd0b49fd9ca6c5a$var$shouldScrollToAnchor) {
        const anchor = document.querySelector('#pagination-anchor');
        if (anchor) anchor.scrollIntoView({
            behavior: 'smooth'
        });
        $0dd0b49fd9ca6c5a$var$shouldScrollToAnchor = false;
    }
    // On mobile only - when filters are opened in a modal.
    // The overlay and close button needs to be re-added to the modal when filters are applied and the modal is open.
    if (window.innerWidth < 1024 && archiveFilters) {
        (0, $c34fafc86f04ace2$export$89f8829913472d51)(archiveFilters);
        (0, $c34fafc86f04ace2$export$dd20ac38e791b8d0)(archiveFilters.querySelector('div:last-child'));
    }
}
/**
 * Update archive via fetch
 */ async function $0dd0b49fd9ca6c5a$var$updateArchive(url) {
    const productListing = document.querySelector('ul.products');
    const wooWidgets = document.querySelectorAll('.woo-widget, .woocommerce-ordering');
    if (productListing) productListing.classList.add('animate-pulse');
    if (window.innerWidth < 1024 && wooWidgets) wooWidgets.forEach((widget)=>widget.classList.add('animate-pulse'));
    const response = await fetch(url, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    });
    const html = await response.text();
    $0dd0b49fd9ca6c5a$var$archivePrefetchCache.set(url, html);
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    $0dd0b49fd9ca6c5a$var$updateArchiveDomFromDoc(doc);
    // Update active filters count
    $0dd0b49fd9ca6c5a$var$updateActiveFiltersCount();
}
/**
 * Update archive using cached HTML
 */ function $0dd0b49fd9ca6c5a$var$updateArchiveFromHTML(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    $0dd0b49fd9ca6c5a$var$updateArchiveDomFromDoc(doc);
    // Update active filters count
    $0dd0b49fd9ca6c5a$var$updateActiveFiltersCount();
}
/**
 * CLICK HANDLING (filters + pagination)
 */ document.addEventListener('click', (e)=>{
    const link = e.target.closest('a');
    if (!link) return;
    const isFilter = link.closest('.woo-widget');
    const isPagination = link.closest('.woocommerce-pagination');
    // Only handle filters + pagination
    if (!isFilter && !isPagination) return;
    // Underkategori-widgeten byter KATEGORI (inte bara filtrerar nuvarande vy) —
    // låt dess länkar navigera normalt istället för att ajax-swappa innehållet.
    if (link.closest('.widget_lw_category_subfilter')) return;
    e.preventDefault();
    const url = link.href;
    // Mark scroll needed only for pagination
    $0dd0b49fd9ca6c5a$var$shouldScrollToAnchor = !!isPagination;
    // Lazy URL update (clean browser history)
    $0dd0b49fd9ca6c5a$var$lazyUpdateUrl(url);
    // Use prefetch cache if available
    if ($0dd0b49fd9ca6c5a$var$archivePrefetchCache.has(url)) $0dd0b49fd9ca6c5a$var$updateArchiveFromHTML($0dd0b49fd9ca6c5a$var$archivePrefetchCache.get(url));
    else $0dd0b49fd9ca6c5a$var$updateArchive(url);
});
/**
 * UPDATE ACTIVE FILTERS COUNT
 */ function $0dd0b49fd9ca6c5a$var$updateActiveFiltersCount() {
    const widget_layered_nav_filters = document.querySelector('.widget_layered_nav_filters');
    const activeFiltersCount = document.querySelector('.active-filters-count');
    if (!widget_layered_nav_filters && !activeFiltersCount) return;
    if (!widget_layered_nav_filters) {
        activeFiltersCount.classList.remove('active');
        activeFiltersCount.textContent = '0';
        return;
    }
    const activeFilters = widget_layered_nav_filters.querySelectorAll('li.chosen');
    if (activeFilters.length > 0) {
        activeFiltersCount.classList.add('active');
        activeFiltersCount.textContent = activeFilters.length;
    }
}
document.addEventListener('DOMContentLoaded', ()=>{
    $0dd0b49fd9ca6c5a$var$updateActiveFiltersCount();
});
/**
 * HOVER-PREFETCH pagination links
 */ document.addEventListener('mouseover', (e)=>{
    const link = e.target.closest('.woocommerce-pagination a');
    if (link) $0dd0b49fd9ca6c5a$var$prefetchArchive(link.href);
});
/**
 * SORTING
 */ document.addEventListener('change', (e)=>{
    if (!e.target.matches('.woocommerce-ordering .orderby')) return;
    const url = new URL(location.href);
    url.searchParams.set('orderby', e.target.value);
    e.preventDefault();
    $0dd0b49fd9ca6c5a$var$shouldScrollToAnchor = false // no scroll on sorting
    ;
    $0dd0b49fd9ca6c5a$var$lazyUpdateUrl(url.toString());
    if ($0dd0b49fd9ca6c5a$var$archivePrefetchCache.has(url.toString())) $0dd0b49fd9ca6c5a$var$updateArchiveFromHTML($0dd0b49fd9ca6c5a$var$archivePrefetchCache.get(url.toString()));
    else $0dd0b49fd9ca6c5a$var$updateArchive(url.toString());
});
/**
 * BACK/FORWARD with popstate
 */ window.addEventListener('popstate', ()=>{
    const url = location.href;
    $0dd0b49fd9ca6c5a$var$shouldScrollToAnchor = false // never auto-scroll when navigating history
    ;
    if ($0dd0b49fd9ca6c5a$var$archivePrefetchCache.has(url)) $0dd0b49fd9ca6c5a$var$updateArchiveFromHTML($0dd0b49fd9ca6c5a$var$archivePrefetchCache.get(url));
    else $0dd0b49fd9ca6c5a$var$updateArchive(url);
});


/**
 * Hierarchical category list with collapsible subcategories (accordion).
 * Targets the WC product categories widget rendered with "Show hierarchy" enabled.
 */ 
const $2d913af866fcae63$var$ROOT_SELECTOR = '.product-category-filters';
const $2d913af866fcae63$var$SIDEBAR_SELECTOR = '.product-categories-sidebar';
const $2d913af866fcae63$var$PARENT_SELECTOR = 'li.cat-parent';
const $2d913af866fcae63$var$ACTIVE_PARENT_CLASSES = [
    'current-cat',
    'current-cat-parent',
    'current-cat-ancestor'
];
function $2d913af866fcae63$var$buildToggleButton() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'category-accordion-toggle';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Visa underkategorier');
    button.innerHTML = `
        <svg class="category-accordion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="9 6 15 12 9 18"></polyline>
        </svg>
    `;
    return button;
}
function $2d913af866fcae63$var$shouldStartExpanded(parentLi) {
    return $2d913af866fcae63$var$ACTIVE_PARENT_CLASSES.some((cls)=>parentLi.classList.contains(cls));
}
// Synligheten styrs av CSS (archive.css) via klasser på <li>, så att
// starttillståndet redan stämmer vid första renderingen och inget hoppar (CLS).
function $2d913af866fcae63$var$setExpanded(button, parentLi, expanded) {
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    parentLi.classList.toggle('is-expanded', expanded);
    parentLi.classList.toggle('is-collapsed', !expanded);
}
function $2d913af866fcae63$var$initAccordion() {
    const root = document.querySelector($2d913af866fcae63$var$ROOT_SELECTOR);
    if (!root) return;
    const parents = root.querySelectorAll($2d913af866fcae63$var$PARENT_SELECTOR);
    parents.forEach((parentLi)=>{
        if (parentLi.dataset.accordionInit === 'true') return;
        const childList = parentLi.querySelector(':scope > ul.children');
        if (!childList) return;
        parentLi.dataset.accordionInit = 'true';
        parentLi.classList.add('has-accordion');
        const button = $2d913af866fcae63$var$buildToggleButton();
        const link = parentLi.querySelector(':scope > a');
        if (link) link.insertAdjacentElement('afterend', button);
        else parentLi.prepend(button);
        button.setAttribute('aria-expanded', $2d913af866fcae63$var$shouldStartExpanded(parentLi) ? 'true' : 'false');
        button.addEventListener('click', (e)=>{
            e.preventDefault();
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            $2d913af866fcae63$var$setExpanded(button, parentLi, !isExpanded);
        });
    });
}
document.addEventListener('DOMContentLoaded', $2d913af866fcae63$var$initAccordion);
/**
 * Toggle the categories sidebar into a modal on mobile (< lg breakpoint).
 * Targets the sidebar wrapper (not the widget) so modal.js finds an inner <div>.
 * Delar logik med arkivfiltren via initResponsiveModal.
 */ function $2d913af866fcae63$var$handleModalAttributesForCategories() {
    (0, $115be675649c4b0c$export$d613139c64264077)($2d913af866fcae63$var$SIDEBAR_SELECTOR, 'categories');
}
document.addEventListener('DOMContentLoaded', $2d913af866fcae63$var$handleModalAttributesForCategories);


// Trunkering + smooth toggle av term-beskrivning på produkt-taxonomi-arkiv.
// CSS klampar till 4 rader via max-h-[4lh]; JS animerar max-height mellan
// klamphöjd och scrollHeight.
//
// Både knappen och fadningen längst ner är "det finns mer att läsa"-signaler och
// visas därför bara när texten faktiskt trunkeras. Fadningen renderas som
// default i PHP (så lång text får signalen även utan JS) och döljs här när den
// inte behövs. Kontrollen görs om vid resize — samma text kan få plats på bred
// skärm men klampas på smal.
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-term-description]').forEach(function(wrap) {
        const text = wrap.querySelector('[data-term-description-text]');
        const btn = wrap.querySelector('[data-term-description-toggle]');
        if (!text || !btn) return;
        const fade = wrap.querySelector('[data-term-description-fade]');
        let expanded = false;
        // Säkerhetsmarginal mot rundningsfel i scrollHeight/clientHeight.
        // Giltig endast i hopfällt läge: expanderat är max-height släppt och
        // scrollHeight === clientHeight.
        function isClamped() {
            return text.scrollHeight > text.clientHeight + 1;
        }
        function syncAffordances() {
            if (expanded) return;
            const clamped = isClamped();
            btn.classList.toggle('hidden', !clamped);
            if (fade) fade.classList.toggle('hidden', !clamped);
        }
        syncAffordances();
        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(syncAffordances, 150);
        });
        function onTransitionEnd(e) {
            if (e.propertyName !== 'max-height') return;
            // Vid expanderat tillstånd: släpp max-height så innehållet kan reflowa
            // (t.ex. vid window resize) utan att klippas.
            if (expanded) text.style.maxHeight = 'none';
            text.removeEventListener('transitionend', onTransitionEnd);
        }
        btn.addEventListener('click', function() {
            text.removeEventListener('transitionend', onTransitionEnd);
            if (!expanded) {
                text.classList.add('expanded');
                // Expandera: animera från nuvarande klamphöjd till full scrollHeight.
                text.style.maxHeight = text.clientHeight + 'px';
                // Force reflow så att övergången ser startvärdet.
                text.offsetHeight;
                text.style.maxHeight = text.scrollHeight + 'px';
            } else {
                text.classList.remove('expanded');
                // Fäll ihop: börja från nuvarande full höjd och animera ner till klamp.
                text.style.maxHeight = text.scrollHeight + 'px';
                text.offsetHeight;
                text.style.maxHeight = '' // tomt = fall tillbaka till CSS (max-h-[4lh])
                ;
            }
            text.addEventListener('transitionend', onTransitionEnd);
            expanded = !expanded;
            btn.querySelector('span').textContent = expanded ? btn.dataset.labelLess : btn.dataset.labelMore;
            btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
    });
});


// Qty-kontroller i checkout review-order-tabellen.
// Debounce-AJAX till lw_update_mini_cart_qty och papperskorgs-remove via lw_remove_cart_item.
// Efter lyckat anrop triggas update_checkout så WC räknar om totaler och fragment.
(function() {
    if (typeof jQuery === 'undefined') return;
    const $ = jQuery;
    const DEBOUNCE_MS = 400;
    const qtyTimers = new Map();
    function ajaxUrl() {
        return window.liGlobal?.ajaxUrl || '/wp-admin/admin-ajax.php';
    }
    function postUpdateQty(key, qty) {
        return $.ajax({
            url: ajaxUrl(),
            method: 'POST',
            data: {
                action: 'lw_update_mini_cart_qty',
                cart_item_key: key,
                quantity: qty
            }
        });
    }
    function postRemove(key) {
        return $.ajax({
            url: ajaxUrl(),
            method: 'POST',
            data: {
                action: 'lw_remove_cart_item',
                cart_item_key: key
            }
        });
    }
    function refreshCheckout() {
        $(document.body).trigger('update_checkout');
    }
    // Min-antal-varningarna (kategori: "Minst 2 st från Träd …", häck: "minsta
    // kvantitet är 60 st") räknas aldrig om av wc-ajax=update_order_review — den
    // kör calculate_totals() men inte woocommerce_check_cart_items. Utan det här
    // står varningen kvar från sidladdningen, även för rader som tagits bort.
    // Serverns qty-/remove-svar bär därför med sig färsk HTML (eller tom sträng
    // när kravet är uppfyllt) — se includes/woocommerce/ajax-mini-cart.php.
    const WARNINGS = [
        {
            key: 'category_warning',
            selector: '[data-lw-category-min]'
        },
        {
            key: 'hedge_warning',
            selector: '[data-lw-hedge-min]'
        }
    ];
    function applyWarning(response, key, selector) {
        if (!response || !response.success || !response.data) return;
        if (typeof response.data[key] !== 'string') return;
        const html = response.data[key];
        const existing = $(selector);
        if (!html) {
            existing.remove();
            return;
        }
        if (existing.length) {
            existing.not(':first').remove();
            existing.first().replaceWith(html);
            return;
        }
        // Ingen varning fanns vid sidladdningen — lägg den där WC skriver sina
        // notiser, annars först i kassans wrapper.
        let $host = $('.woocommerce-notices-wrapper').first();
        if (!$host.length) $host = $('<div class="woocommerce-notices-wrapper"></div>').prependTo($('.woocommerce').first());
        $host.append(html);
    }
    function onCartChanged(response) {
        WARNINGS.forEach((w)=>applyWarning(response, w.key, w.selector));
        refreshCheckout();
    }
    function scheduleQtyUpdate(input) {
        const key = input.dataset.cartItemKey;
        if (!key) return;
        let qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        if (qtyTimers.has(key)) clearTimeout(qtyTimers.get(key));
        const timer = setTimeout(function() {
            qtyTimers.delete(key);
            postUpdateQty(key, qty).done(onCartChanged);
        }, DEBOUNCE_MS);
        qtyTimers.set(key, timer);
    }
    $(document).on('click', '.lw-checkout-qty-plus', function(e) {
        e.preventDefault();
        const wrap = this.closest('.lw-checkout-qty');
        if (!wrap) return;
        const input = wrap.querySelector('.lw-checkout-qty-input');
        if (!input) return;
        const current = parseInt(input.value, 10);
        input.value = isNaN(current) ? 1 : current + 1;
        scheduleQtyUpdate(input);
    });
    $(document).on('click', '.lw-checkout-qty-minus', function(e) {
        e.preventDefault();
        const wrap = this.closest('.lw-checkout-qty');
        if (!wrap) return;
        const input = wrap.querySelector('.lw-checkout-qty-input');
        if (!input) return;
        const current = parseInt(input.value, 10);
        const next = Math.max(1, isNaN(current) ? 1 : current - 1);
        input.value = next;
        scheduleQtyUpdate(input);
    });
    $(document).on('input change', '.lw-checkout-qty-input', function() {
        scheduleQtyUpdate(this);
    });
    $(document).on('click', '.lw-checkout-qty-remove', function(e) {
        e.preventDefault();
        const key = this.dataset.key;
        if (!key) return;
        postRemove(key).done(onCartChanged);
    });
    // Cross-sells "Lägg till"-knapp för enkla produkter — använder WC:s add_to_cart
    // wc-ajax-endpoint men avbryter event så den yttre <a> inte navigerar och
    // mini-cartens egen klick-handler inte triggar.
    $(document).on('click', '.lw-checkout-cross-sell-add', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const btn = $(this);
        const productId = btn.data('product-id');
        if (!productId) return;
        if (btn.prop('disabled')) return;
        const tpl = window.wc_add_to_cart_params?.wc_ajax_url || '/?wc-ajax=%%endpoint%%';
        const url = tpl.replace('%%endpoint%%', 'add_to_cart');
        const originalText = btn.text();
        btn.prop('disabled', true);
        if (window.liGlobal?.addingToCartText) btn.text(window.liGlobal.addingToCartText);
        $.ajax({
            url: url,
            method: 'POST',
            data: {
                product_id: productId,
                quantity: 1
            },
            success: function() {
                refreshCheckout();
            },
            complete: function() {
                btn.prop('disabled', false);
                btn.text(originalText);
            }
        });
    });
})();
// Synka utlämningsställe om det finns flera paket i checkout
function $43537babcb813f13$var$syncShippingAddress(sourceSelect) {
    if (!document.body.classList.contains('woocommerce-checkout')) return;
    const selects = document.querySelectorAll('.postnord_servicepoints');
    if (!selects || selects.length < 2) return;
    const primary = selects[0] // ENDAST denna lyssnar vi på
    ;
    const secondary = selects[1] // denna synkas (kan döljas visuellt)
    ;
    // Säkerställ att vi bara syncar när eventet kommer från primary
    if (sourceSelect !== primary) return;
    // Sätt värdet
    secondary.value = primary.value;
    // Trigga change så ev. annan logik (Postnord/Woo) reagerar
    secondary.dispatchEvent(new Event('change', {
        bubbles: true
    }));
}
// Synka radioknapparna (shipping method) mellan första och andra paketet
function $43537babcb813f13$var$syncShippingRadios(sourceRadio) {
    if (!document.body.classList.contains('woocommerce-checkout')) return;
    if (!sourceRadio) return;
    // ENDAST primary-gruppen ska styra
    if (sourceRadio.name !== 'shipping_method[0]') return;
    if (!sourceRadio.classList.contains('shipping_method')) return;
    // Hitta motsvarande radio i andra paketet (andra indexet)
    const secondaryRadios = document.querySelectorAll('input.shipping_method[type="radio"]:not([name="shipping_method[0]"])');
    if (!secondaryRadios || !secondaryRadios.length) return;
    for (const r of secondaryRadios){
        if (r.value !== sourceRadio.value) continue;
        if (r.checked) break;
        r.checked = true;
        r.dispatchEvent(new Event('change', {
            bubbles: true
        }));
        break;
    }
}
document.addEventListener('change', (e)=>{
    // Select sync
    if (e.target.matches('.postnord_servicepoints')) {
        $43537babcb813f13$var$syncShippingAddress(e.target);
        return;
    }
    // Radio sync
    if (e.target.matches('input.shipping_method[type="radio"]')) {
        $43537babcb813f13$var$syncShippingRadios(e.target);
        return;
    }
});
// (Valfritt) Kör en gång direkt så att initialt värde också syncas
document.addEventListener('DOMContentLoaded', ()=>{
    const selects = document.querySelectorAll('.postnord_servicepoints');
    if (selects && selects.length >= 2) {
        selects[1].value = selects[0].value;
        selects[1].dispatchEvent(new Event('change', {
            bubbles: true
        }));
    }
    // Initial radio sync (if something is already selected in primary)
    const primaryChecked = document.querySelector('input.shipping_method[type="radio"][name="shipping_method[0]"]:checked');
    if (primaryChecked) $43537babcb813f13$var$syncShippingRadios(primaryChecked);
});


// Eget rabattkodsfält i kassan (lw_checkout_coupon_field).
// Applicerar/tar bort kupong via AJAX (lw_apply_coupon / lw_remove_coupon) och triggar
// sedan update_checkout så att WC räknar om order review + totaler.
//
// Fältet ligger inuti order review-tabellen (efter delsumman), som update_checkout byter ut.
// Applicerade kuponger renderas därför färskt från servern vid omräkningen, medan senaste
// notis återinjiceras här efter "updated_checkout" (annars hade den rensats vid omritningen).
(function() {
    const WIDGET_ID = 'lw-coupon';
    // Notis som ska visas igen efter att update_checkout ritat om fältet. null = inget väntande.
    let pendingNotices = null;
    // Öppet/stängt-läge för <details> bevaras över omritningar (update_checkout byter ut fältet).
    let wasOpen = false;
    function ajaxUrl() {
        return window.liGlobal?.ajaxUrl || '/wp-admin/admin-ajax.php';
    }
    function refreshCheckout() {
        if (window.jQuery) window.jQuery(document.body).trigger('update_checkout');
    }
    function widget() {
        return document.getElementById(WIDGET_ID);
    }
    function setNotices(html) {
        const el = widget();
        const noticesEl = el && el.querySelector('.lw-coupon-notices');
        if (noticesEl) noticesEl.innerHTML = html || '';
    }
    // Innan WC ritar om: kom ihåg om fältet var öppet så vi kan återställa det.
    // Efter omritningen: återställ öppet-läge + senaste notis i det nya fältet.
    if (window.jQuery) {
        window.jQuery(document.body).on('update_checkout', function() {
            const el = widget();
            if (el) wasOpen = el.open;
        });
        window.jQuery(document.body).on('updated_checkout', function() {
            const el = widget();
            if (el && wasOpen) el.open = true;
            if (pendingNotices === null) return;
            setNotices(pendingNotices);
            pendingNotices = null;
        });
    }
    // Skicka AJAX-anrop och uppdatera fältet med svaret.
    function post(action, couponCode) {
        const el = widget();
        if (!el) return;
        const nonce = el.dataset.nonce || '';
        const noticesEl = el.querySelector('.lw-coupon-notices');
        const appliedEl = el.querySelector('.lw-coupon-applied');
        const applyBtn = el.querySelector('.lw-coupon-apply');
        if (applyBtn) applyBtn.disabled = true;
        el.querySelectorAll('.lw-coupon-remove').forEach((b)=>b.disabled = true);
        const body = new URLSearchParams({
            action: action,
            nonce: nonce,
            coupon_code: couponCode
        });
        fetch(ajaxUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: body.toString()
        }).then((r)=>r.json()).then((res)=>{
            const data = res?.data || {};
            // Direkt feedback i nuvarande fält ...
            if (noticesEl) noticesEl.innerHTML = data.notices || '';
            if (appliedEl) appliedEl.innerHTML = data.coupons || '';
            // ... och spara notisen så den återställs efter att update_checkout ritat om fältet.
            pendingNotices = data.notices || '';
            refreshCheckout();
        }).catch(()=>{
            if (noticesEl) noticesEl.innerHTML = '<div class="woocommerce-error">N\xe5got gick fel. F\xf6rs\xf6k igen.</div>';
        }).finally(()=>{
            if (applyBtn) applyBtn.disabled = false;
        });
    }
    function applyCoupon() {
        const input = document.getElementById('lw-coupon-code');
        if (!input) return;
        const code = input.value.trim();
        if (!code) return;
        post('lw_apply_coupon', code);
        input.value = '';
    }
    // Delegerade events — fältet kan re-renderas vid behov.
    document.addEventListener('click', function(e) {
        const applyBtn = e.target.closest('.lw-coupon-apply');
        if (applyBtn) {
            e.preventDefault();
            applyCoupon();
            return;
        }
        const removeBtn = e.target.closest('.lw-coupon-remove');
        if (removeBtn) {
            e.preventDefault();
            post('lw_remove_coupon', removeBtn.dataset.coupon || '');
        }
    });
    // Enter i inputfältet ska applicera, inte posta checkout-formuläret.
    document.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter') return;
        if (e.target && e.target.id === 'lw-coupon-code') {
            e.preventDefault();
            applyCoupon();
        }
    });
})();


// Behåll orderkommentaren i kassan när sidan laddas om.
// WC sparar inte order_comments i sessionen, så fältet töms när Svea laddar om
// kassan (byte av betalsätt via "Andra betalsätt", nekat köp, nonce-förnyelse).
// Texten speglas till sessionStorage och läggs tillbaka i ett tomt fält vid
// sidladdning och efter updated_checkout. Rensas på tack-sidan.
(function() {
    const KEY = 'lw_order_comments';
    const SELECTOR = 'textarea[name="order_comments"]';
    function read() {
        try {
            return window.sessionStorage.getItem(KEY) || '';
        } catch (e) {
            return '';
        }
    }
    function write(value) {
        try {
            if (value.trim()) window.sessionStorage.setItem(KEY, value);
            else window.sessionStorage.removeItem(KEY);
        } catch (e) {}
    }
    function restore() {
        const saved = read();
        if (!saved) return;
        document.querySelectorAll(SELECTOR).forEach((field)=>{
            if (!field.value) field.value = saved;
        });
    }
    function init() {
        if (document.body.classList.contains('woocommerce-order-received')) {
            write('');
            return;
        }
        if (!document.body.classList.contains('woocommerce-checkout')) return;
        restore();
        document.addEventListener('input', (e)=>{
            if (e.target.matches && e.target.matches(SELECTOR)) write(e.target.value);
        });
        if (typeof jQuery !== 'undefined') jQuery(document.body).on('updated_checkout', restore);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();


// Uppdatera variations-attribut (t.ex. Storlek) och custom variations-fält
// (Rotsystem, Antal per löpmeter) i Produktfakta när man byter variant.
//
// Attribut-värden renderas av servern i
// <span class="lw-variation-attr-value" data-attribute="attribute_pa_storlek">125-150 cm</span>.
// Custom-fält renderas i en egen <span> (se CUSTOM_FIELDS) och uppdateras via
// WC:s found_variation-event som ger oss variantens JSON-data.
(function() {
    // key = nyckeln i variationens JSON (satt via woocommerce_available_variation),
    // selector = spanen som PHP renderar i Produktfakta-raden.
    const CUSTOM_FIELDS = [
        {
            key: 'rotsystem',
            selector: '.lw-rotsystem-value'
        },
        {
            key: 'rek_antal_per_lopmeter',
            selector: '.lw-rek-antal-value'
        }
    ];
    function updateProductFacts() {
        const form = document.querySelector('form.variations_form');
        if (!form) return;
        document.querySelectorAll('.lw-variation-attr-value[data-attribute]').forEach((span)=>{
            const select = form.querySelector(`select[name="${span.dataset.attribute}"]`);
            if (!select) return;
            const opt = select.options[select.selectedIndex];
            if (opt && opt.value) span.textContent = opt.text;
        });
    }
    // Sätter bara värdet. Om raden ska synas eller inte avgörs deklarativt av
    // CSS (:has(.lw-…-value:empty) i src/css/woocommerce/single-product.css),
    // så tom variant → dold rad utan att JS rör style.
    function updateCustomField(selector, value) {
        const span = document.querySelector(selector);
        if (!span) return;
        span.textContent = value ? String(value).trim() : '';
    }
    function updateCustomFields(variation) {
        CUSTOM_FIELDS.forEach((field)=>{
            updateCustomField(field.selector, variation && variation[field.key]);
        });
    }
    // Vanilla change på variations-formulärets selects (täcker även .variation-button-UI:t
    // som dispatchar change på select).
    document.addEventListener('change', (e)=>{
        if (e.target.matches && e.target.matches('form.variations_form select')) updateProductFacts();
    });
    // WC:s found_variation (jQuery) ger oss variantens kompletta JSON-data.
    // Behövs för custom-fält som inte finns i select-optionerna.
    if (window.jQuery) window.jQuery(function($) {
        $('form.variations_form').on('found_variation', function(event, variation) {
            updateProductFacts();
            updateCustomFields(variation);
        });
        $('form.variations_form').on('reset_data', function() {
            updateCustomFields(null);
        });
    });
    document.addEventListener('DOMContentLoaded', updateProductFacts);
})();


// Per-variation galleri — byter ut .woocommerce-product-gallery vid variantbyte.
//
// Flödet:
//   1. Vid sidladdning cachas original-galleriets outerHTML.
//   2. På found_variation: om variation.gallery_image_html är icke-tom,
//      ersätt hela .woocommerce-product-gallery och re-initiera WC:s
//      flexslider/photoswipe via $.fn.wc_product_gallery.
//   3. På reset_data: återställ original-galleriet.
//
// Beroende: jQuery + WC:s frontend-scripts (laddas alltid på produktsida).
(function() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    // WooCommerce 10.8:s inbyggda variantbildhantering (wc_variations_image_update)
    // körs också på found_variation och byter ut HUVUDBILDEN (slide 0) mot
    // variantens featured-bild (variation.image). Det här temat har ett eget
    // per-variant-galleri som byter ut HELA galleriet (slides + miniatyrer). WC:s
    // single-image-swap krockar då med vårt: den skriver över slide 0 med en annan
    // bild än den vi lagt in (variantens featured-bild ≠ galleriets första bild),
    // så huvudbilden och miniatyrraden hamnar i osync. Resultatet är att första
    // miniatyren pekar på en redan aktiv slide → den "går inte att klicka på", och
    // huvudbilden kan lämnas blank.
    //
    // Neutralisera WC:s single-image-swap för just de varianter vi äger galleriet
    // för (de har gallery_image_html i variantdatan). WC:s standardbeteende lämnas
    // orört för alla andra produkter/varianter.
    //
    // Anropas både direkt och vid ready: WC:s add-to-cart-variation.js kan laddas
    // efter tema-bundlen, så $.fn.wc_variations_image_update finns inte alltid när
    // IIFE:n körs. Vid ready är alla script parsade.
    function patchWcVariationsImageUpdate() {
        if (!$.fn.wc_variations_image_update || $.fn.__lwVariationGalleryPatched) return;
        var _wcVariationsImageUpdate = $.fn.wc_variations_image_update;
        $.fn.wc_variations_image_update = function(variation) {
            if (variation && variation.gallery_image_html) return this;
            return _wcVariationsImageUpdate.apply(this, arguments);
        };
        $.fn.__lwVariationGalleryPatched = true;
    }
    patchWcVariationsImageUpdate();
    var originalGalleryHtml = null;
    function captureOriginal() {
        if (originalGalleryHtml !== null) return;
        var el = document.querySelector('.woocommerce-product-gallery');
        if (el) originalGalleryHtml = el.outerHTML;
    }
    function reinitGallery($gallery) {
        if (typeof $gallery.wc_product_gallery !== 'function') return;
        var params = window.wc_single_product_params || {};
        $gallery.trigger('wc-product-gallery-before-init', [
            $gallery.get(0),
            params
        ]);
        $gallery.wc_product_gallery(params);
        $gallery.trigger('wc-product-gallery-after-init', [
            $gallery.get(0),
            params
        ]);
        revealGallery($gallery);
    }
    // Markupen har opacity:0 inline (matchar WC:s template) så inget syns förrän vi
    // avslöjar den. Flexslider måste dessutom räkna om viewport-höjden efter att
    // galleriet bytts ut och huvudbilden laddats — annars kan slide 0 lämnas med
    // kollapsad höjd / inaktuell målning (blank huvudbild på ett GPU-kompositlager).
    // WC:s egen galleriswap löser detta genom att trigga ett window-resize kort
    // efter bytet, vilket får flexslider att räkna om och måla om. Vi speglar det,
    // och triggar även en gång till när huvudbilden laddats (ifall den inte hunnit
    // ladda vid första resizen).
    function revealGallery($gallery) {
        $gallery.css('opacity', '');
        // Ett window-resize får flexslider att räkna om viewport-höjden och måla om
        // kompositlagret. Vi triggar över flera frames för att täcka både bildens
        // laddningstid och flexsliders interna debounce — annars kan slide 0 lämnas
        // blank (inaktuell målning på GPU-lagret) trots att DOM:en är korrekt.
        var settle = function() {
            $(window).trigger('resize');
        };
        requestAnimationFrame(settle);
        window.setTimeout(settle, 80);
        window.setTimeout(settle, 300);
        var img = $gallery.find('.woocommerce-product-gallery__image').first().find('img').get(0);
        if (img && !(img.complete && img.naturalWidth > 0)) $(img).one('load', function() {
            requestAnimationFrame(settle);
        });
    }
    // Galleribilderna renderas serverside med loading="lazy". När vi injicerar
    // galleriet via JS efter sidladdning triggas aldrig webbläsarens lazy-load-path
    // tillförlitligt — inte ens för huvudbilden som ligger i viewporten — så slidsen
    // förblir tomma tills en orelaterad reflow råkar väcka dem.
    //
    // Sätts eager INNAN elementen sätts in i DOM:en, så att bilderna laddas som en
    // vanlig eager-bild (precis som container-galleriet gör).
    function forceEagerImages($gallery) {
        $gallery.find('.woocommerce-product-gallery__image img').each(function() {
            this.setAttribute('loading', 'eager');
        });
    }
    function swapGallery(html) {
        if (!html) return;
        var $existing = $('.woocommerce-product-gallery').first();
        if (!$existing.length) return;
        var $new = $($.parseHTML(html, document, true)).filter('.woocommerce-product-gallery').first();
        if (!$new.length) // Fallback om filter-resultatet inte hittade wrappen (t.ex. om
        // gallery_image_html inte börjar med själva wrappen).
        $new = $('<div>').html(html).find('.woocommerce-product-gallery').first();
        if (!$new.length) return;
        forceEagerImages($new);
        $existing.replaceWith($new);
        reinitGallery($new);
    }
    $(function() {
        patchWcVariationsImageUpdate();
        captureOriginal();
        var $forms = $('form.variations_form');
        if (!$forms.length) return;
        $forms.on('found_variation', function(event, variation) {
            if (variation && variation.gallery_image_html) swapGallery(variation.gallery_image_html);
            else if (originalGalleryHtml) // Variant utan eget galleri → fall tillbaka till container.
            swapGallery(originalGalleryHtml);
        });
        $forms.on('reset_data', function() {
            if (originalGalleryHtml) swapGallery(originalGalleryHtml);
        });
    });
})();


// Custom variant-dropdown för höjd/storlek på produktsidan.
//
// Servern renderar både WC:s vanliga <select> och en custom dropdown
// (se lw_single_product_variation_dropdown.php). Den här filen:
//   1. Döljer den native selecten och visar custom-dropdownen (progressiv förbättring).
//   2. Öppnar/stänger listan (state via aria-expanded → CSS sköter visning + chevron).
//   3. Speglar klick tillbaka till <select> via jQuery .change() så WC:s
//      variations_form reagerar (pris, galleri, pristrappor uppdateras som vanligt).
//   4. Uppdaterar knappen när valet ändras — även när WC själv sätter default
//      eller nollställer (reset_variations).
//
// jQuery används medvetet för select-eventet: WC triggar 'change' via jQuery, och
// native addEventListener fångar inte jQuery-triggade events tillförlitligt.
(function() {
    function initDropdown(wrapper) {
        var toggle = wrapper.querySelector('[data-lw-vardrop-toggle]');
        var panel = wrapper.querySelector('[data-lw-vardrop-panel]');
        var labelEl = wrapper.querySelector('[data-lw-vardrop-label]');
        var metaEl = wrapper.querySelector('[data-lw-vardrop-meta]');
        if (!toggle || !panel || !labelEl || !metaEl) return;
        var cell = wrapper.closest('.value') || wrapper.parentElement;
        var select = cell ? cell.querySelector('select') : null;
        if (!select) return;
        var placeholder = wrapper.getAttribute('data-placeholder') || labelEl.textContent;
        var options = Array.prototype.slice.call(panel.querySelectorAll('[data-lw-vardrop-option]'));
        // Byt fältetikett ("Storlek" → "Välj storlek") och placera rea-summeringen
        // ("Rea på X av Y storlekar") inline bredvid den. WC:s label ligger i en
        // egen tabellcell (core-template), därför sköts det här i JS.
        var row = wrapper.closest('tr');
        var fieldLabelEl = row ? row.querySelector('label') : null;
        if (fieldLabelEl) {
            var fieldLabel = wrapper.getAttribute('data-field-label');
            var saleSummary = wrapper.getAttribute('data-sale-summary');
            if (fieldLabel) fieldLabelEl.textContent = fieldLabel;
            if (saleSummary) fieldLabelEl.insertAdjacentHTML('beforeend', saleSummary);
        }
        // Aktivera custom-UI, dölj native select.
        select.classList.add('lw-vardrop-native-hidden');
        wrapper.classList.add('is-active');
        function isOpen() {
            return toggle.getAttribute('aria-expanded') === 'true';
        }
        function open() {
            toggle.setAttribute('aria-expanded', 'true');
        }
        function close() {
            toggle.setAttribute('aria-expanded', 'false');
        }
        function setSelectValue(value) {
            if (window.jQuery) window.jQuery(select).val(value).trigger('change');
            else {
                select.value = value;
                select.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            }
        }
        // Speglar aktuellt select-värde till knappen + markerar aktiv rad.
        function reflect(value) {
            var matched = null;
            options.forEach(function(opt) {
                var isSel = value !== '' && opt.getAttribute('data-value') === value;
                opt.setAttribute('aria-selected', isSel ? 'true' : 'false');
                if (isSel) matched = opt;
            });
            if (matched) {
                labelEl.textContent = matched.getAttribute('data-label') || '';
                metaEl.innerHTML = matched.getAttribute('data-toggle-meta') || '';
            } else {
                labelEl.textContent = placeholder;
                metaEl.innerHTML = '';
            }
        }
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            if (isOpen()) close();
            else open();
        });
        options.forEach(function(opt) {
            opt.addEventListener('click', function(e) {
                e.preventDefault();
                setSelectValue(opt.getAttribute('data-value'));
                reflect(opt.getAttribute('data-value'));
                close();
                toggle.focus();
            });
        });
        // Utanförklick + Escape stänger.
        document.addEventListener('click', function(e) {
            if (isOpen() && !wrapper.contains(e.target)) close();
        });
        wrapper.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && isOpen()) {
                close();
                toggle.focus();
            }
        });
        // Synka när valet ändras (default vid laddning, reset_variations, m.m.).
        function onChange() {
            reflect(select.value);
        }
        if (window.jQuery) window.jQuery(select).on('change', onChange);
        else select.addEventListener('change', onChange);
        reflect(select.value);
    }
    function init() {
        document.querySelectorAll('[data-lw-vardrop]').forEach(initDropdown);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();


// Köpknappen när vald variant (höjd/storlek) inte går att köpa, t.ex. slut i lager.
//
// WC markerar en sådan variant enbart med klasserna .disabled.wc-variation-is-unavailable.
// Knappen tar då fortfarande emot klick: WC öppnar en window.alert ("Den här
// produkten är inte tillgänglig …") och mini-cart.js skickar dessutom köpet,
// som servern avvisar med "Du kan inte lägga till … eftersom produkten är slut
// i lager" under mängdrabatten.
//
// Här sätts i stället disabled-propertyn — en disabled knapp tar inte emot klick,
// så varken alerten eller köpet körs — och texten byts till "Tillfälligt slut i
// lager" när varianten är slut.
//
// jQuery krävs: WC triggar show_variation/hide_variation/reset_data via jQuery.
jQuery(function($) {
    function setButtonState($form, purchasable, inStock) {
        var $button = $form.find('.single_add_to_cart_button');
        if (!$button.length) return;
        $button.prop('disabled', !purchasable);
        $button.toggleClass('lw-out-of-stock', !inStock);
        $button.text(inStock ? liGlobal.addToCartText : liGlobal.outOfStockText);
    }
    $(document.body).on('show_variation', 'form.variations_form', function(e, variation, purchasable) {
        setButtonState($(this), purchasable, !!variation.is_in_stock);
    });
    // Ingen variant vald: tillbaka till WC:s vanliga "välj alternativ"-läge.
    $(document.body).on('hide_variation reset_data', 'form.variations_form', function() {
        setButtonState($(this), true, true);
    });
});


 // jQuery(document.body).on(
 //     [
 //         // Add to cart / cart
 //         'adding_to_cart',
 //         'added_to_cart',
 //         'wc_cart_button_updated',
 //         'removed_from_cart',
 //         'wc_cart_emptied',
 //         'wc_fragment_refresh',
 //         'wc_fragments_refreshed',
 //         'wc_fragments_loaded',
 //         'cart_page_refreshed',
 //         'updated_wc_div',
 //         // Mini cart / fragments
 //         'wc_fragments_loaded',
 //         'wc_fragments_refreshed',
 //         // Checkout lifecycle
 //         'init_checkout',
 //         'update_checkout',
 //         'updated_checkout',
 //         'checkout_error',
 //         'reset_data',
 //         // Cart totals / shipping
 //         'updated_cart_totals',
 //         'cart_totals_refreshed',
 //         'updated_shipping_method',
 //         'country_to_state_changed',
 //         // Coupons
 //         'applied_coupon',
 //         'removed_coupon',
 //         'applied_coupon_in_checkout',
 //         'removed_coupon_in_checkout',
 //         // Payments
 //         'payment_method_selected',
 //         'init_add_payment_method',
 //         // Variations
 //         'found_variation',
 //         'reset_variations',
 //         'hide_variation',
 //         'show_variation',
 //         // Misc / legacy
 //         'updated_checkout',
 //         'updated_cart_totals',
 //     ].join(' '),
 //     function (e, data) {
 //         console.log('[WC EVENT]', e.type, data || null)
 //     }
 // )



if (null) null.accept();

})();
//# sourceMappingURL=app.js.map
